var Airtable = require('airtable');
Airtable.configure({
    // Requests go through our Netlify proxy (/airtable), which injects the real
    // token server-side. The apiKey below is a placeholder the client library
    // requires but the proxy ignores — the real token is never in the bundle.
    endpointUrl: window.location.origin + '/airtable',
    apiKey: 'proxied'
});
var base = Airtable.base('app6GHxtqv6bp7oBk');

window.Airwaves = {}; // global Object container; don't use var

Airwaves.searchInput = document.getElementById('input');
// Airwaves.searchInput.focus(); don't do this anymore

Airwaves.player = document.getElementById('player');
Airwaves.audio = document.getElementById('audio');
Airwaves.alert = document.getElementById('alert');

Airwaves.searchResults = document.getElementById('searchResults');

Airwaves.searchForm = document.querySelector("#search-form");

Airwaves.totalTracks = 0;

Airwaves.queuePast = [];
Airwaves.queueFuture = [];
Airwaves.queueCurrent = [];
Airwaves._navBack = false; // set while navigating to the previous track, so the
                           // track we leave goes forward in the queue, not back

Airwaves.trackCache = [];
Airwaves.collectionCache = [];
Airwaves.artistCache = [];
Airwaves.artistClusterCache = {};
Airwaves.currentArtistCluster = 'ABC';
Airwaves.albumClusterCache = {};
Airwaves.currentAlbumCluster = 'Recent';

Airwaves.audio.onended = (event) => {

  Airwaves.ended();

};

// Shuffle to random track
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
}

// Configure tracksColumns
const tracksColumns = {
  recordID: "Record ID (Airtable)",
  googleDriveURL: "Google Drive Direct Play URL",

  title: "Title",

  artists: "Artists",
  featuredArtists: "Linked Featured Artists Display Names",
  remixArtists: "Linked Remix / VIP Artist Display Names",

  trackName: "Track Name",
  trackNamePlus: "Track Name + Variants",
  trackType: "Track Type",
  trackFile: "Track File",

  album: "Album",
  albumArtwork: "Album Artwork",
  artistIDs: "Link to Artists",
  featuredArtistIDs: "Link to Featured Artists",
  remixArtistIDs: "Link to Remix / VIP Artists",
  artistNamesLookup: "Artists display names lookup",
  featuredArtistNamesLookup: "Featured artists display names lookup",
  remixArtistNamesLookup: "Remix artists display names lookup",
  albumID: "Link to Album",
  playlists: "Playlists",
};

const albumsColumns = {
  recordID: "Record ID (Airtable)",

  name: "Name",

  trackArtists: "Track Artists",

  trackIDs: "Track IDs",
  trackTypes: "Track Types",
  trackCount: "# Tracks",

  tracksAlbumArtworks: "Track's Artworks"
};

const playlistsColumns = {
  recordID: "Record ID (Airtable)",

  name: "Name",

  trackArtists: "Playlist Artists List",

  trackIDs: "Track IDs",
  trackCount: "# Tracks",

  tracksAlbumArtworks: "Track's Artworks"
};

const artistsColumns = {
  recordID: "Record ID",

  displayName: "Display Name",
  imageURL: "Discogs Artist Image URL",

  allTrackIDs: "All Track IDs",
  trackIDsMainArtist: "Track IDs (Main Artist)",
  totalTracks: "# Total Tracks",
  totalAlbums: "# Albums",
  trackAlbums: "Track albums",
  trackAlbumsRecordIDs: "Track albums record IDs"
};

const artistClusters = [
  { key: 'ABC',  label: 'ABC',  letters: ['A','B','C'] },
  { key: 'DEF',  label: 'DEF',  letters: ['D','E','F'] },
  { key: 'GHI',  label: 'GHI',  letters: ['G','H','I'] },
  { key: 'JKL',  label: 'JKL',  letters: ['J','K','L'] },
  { key: 'MNO',  label: 'MNO',  letters: ['M','N','O'] },
  { key: 'PQR',  label: 'PQR',  letters: ['P','Q','R'] },
  { key: 'STUV', label: 'STUV', letters: ['S','T','U','V'] },
  { key: 'WXY',  label: 'WXY',  letters: ['W','X','Y'] },
  { key: 'Z09',  label: 'Z 0–9', letters: ['Z','0','1','2','3','4','5','6','7','8','9'] },
];


// Fields to query Tracks for
const tracksFieldsQuery = [
  tracksColumns["recordID"],
  tracksColumns["googleDriveURL"],

  tracksColumns["title"],

  tracksColumns["artists"],
  tracksColumns["featuredArtists"],
  tracksColumns["remixArtists"],

  tracksColumns["trackName"],
  tracksColumns["trackNamePlus"],
  tracksColumns["trackType"],
  tracksColumns["trackFile"],

  tracksColumns["album"],
  tracksColumns["albumArtwork"],
  tracksColumns["artistIDs"],
  tracksColumns["featuredArtistIDs"],
  tracksColumns["remixArtistIDs"],
  tracksColumns["artistNamesLookup"],
  tracksColumns["featuredArtistNamesLookup"],
  tracksColumns["remixArtistNamesLookup"],
  tracksColumns["albumID"],
  tracksColumns["playlists"],
];

// Fields to query Albums for
const albumsFieldsQuery = [
  albumsColumns["recordID"],

  albumsColumns["name"],

  albumsColumns["trackArtists"],

  albumsColumns["trackIDs"],
  albumsColumns["trackTypes"],
  albumsColumns["trackCount"],

  albumsColumns["tracksAlbumArtworks"]
];

// Fields to query Playlists for
const playlistsFieldsQuery = [
  playlistsColumns["recordID"],

  playlistsColumns["name"],

  playlistsColumns["trackArtists"],

  playlistsColumns["trackIDs"],
  playlistsColumns["trackCount"],

  playlistsColumns["tracksAlbumArtworks"]
];

// Fields to query Artists for
const artistsFieldsQuery = [
  artistsColumns["recordID"],

  artistsColumns["displayName"],
  artistsColumns["imageURL"],

  artistsColumns["allTrackIDs"],
  artistsColumns["trackIDsMainArtist"],
  artistsColumns["totalTracks"],
  artistsColumns["totalAlbums"],
  artistsColumns["trackAlbums"],
  artistsColumns["trackAlbumsRecordIDs"]
];

function componentTemplate(component, variant, data) {

  if(
    component == "trackItem"
  ) {
    let template = "<li>";
      template = template + "<div class='c-track-result' data-recordid='" + data["Record ID"] + "'>"
        template = template + "<button type='button' class='" + (variant == "noControls" ? 'cursor-default' : '') + " c-track-result__thumbnail thumbnail' data-thumbnail-recordid='" + data["Record ID"] + "' loading='lazy' style='background-image: url(" + data["Album Artwork URL"] + ");' " + (variant == "noControls" ? 'tabindex="-1"' : 'data-action="playTrack"') + "  data-recordID='" + data["Record ID"] + "'></button>";

        template = template + "<button type='button' class='" + (variant == "noControls" ? 'state-invisible' : '') + " c-track-result__button c-track-result__button--play' data-action='playTrack' data-recordID='" + data["Record ID"] + "'>";
          template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 8.64L13.77 12L8.5 15.36V8.64ZM6.5 5V19L17.5 12L6.5 5Z" fill="currentColor"/></svg>';
        template = template + "</button>";

        template = template + "<div class='c-track-result__meta'>";
        template = template + "<p class='c-track-result__track-name'>" + data["Track Name"] + "</p>";

        template = template + "<div class='c-track-result__meta-links'>";        

        if(data["Artists"]) {
        
          template = template + '<p class="c-track-result__artists"><svg class="c-track-result__inline-icon u-color-cryan-500" viewBox="0 0 24 24"><path fill="currentColor" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>' + data["Artists"] + '</p>';

        }

        if(data["Remix Artists"] || data["Track Type"]) {
          template = template + '<p class="c-track-result__remix-artists"><svg class="c-track-result__inline-icon u-color-plink-500" viewBox="0 0 24 24"><path fill="currentColor" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>' + data["Remix Artists"] + " " + data["Track Type"] + '</p>';
        }
        
        if(data["Featured Artists"]) {
          template = template + "<p class='c-track-result__featured-artists'>" + data["Featured Artists"] + "</p>";
        }

        if(data["Album"]) {
          template = template + '<p class="c-track-result__album"><svg class="c-track-result__inline-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>' + data["Album"] + '</p>';
        }

        template = template + "</div>";
        template = template + "</div>";

        if(variant === "queue") {

          template = template + "<div class='c-track-result__controls c-track-result__controls--queue'>";
            template = template + "<button type='button' class='c-track-result__button c-track-result__button--remove' data-action='removeFromQueue' data-recordID='" + data["Record ID"] + "' title='Remove from queue'>";
              template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/></svg>';
            template = template + "</button>";
            template = template + "<div class='c-track-result__drag-handle' title='Drag to reorder'>";
              template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" fill="currentColor"/></svg>';
            template = template + "</div>";
          template = template + "</div>";

        } else if(variant !== "noControls") {

          template = template + "<div class='c-track-result__controls'>";

            template = template + "<button type='button' class='c-track-result__button c-track-result__button--addToQueue' data-action='addToQueue' data-recordID='" + data["Record ID"] + "'>";
              template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z" fill="currentColor"/></svg>';
            template = template + "</button>";
          template = template + "</div>";

        }

      template = template + "</div>";
    template = template + "</li>";

    return template;
  }
  else if (
    component == "albumItem"
  ) {
    let template = "<li>";
      template = template + "<div class='c-track-result c-track-result--album' data-recordid='" + data["Record ID"] + "'>"
        template = template + "<button type='button' class='" + (variant == "noControls" ? 'cursor-default' : '') + " c-track-result__thumbnail thumbnail thumbnail--album' data-thumbnail-recordid='" + data["Track IDs"] + "' loading='lazy' style='background-image: url(" + data["Album Artwork"] + ");' " + (variant == "noControls" ? 'tabindex="-1"' : 'data-action="openCollection"') + "  data-recordID='" + data["Record ID"] + "'></button>";

        template = template + "<button type='button' class='" + (variant == "noControls" ? 'state-invisible' : '') + " c-track-result__button c-track-result__button--play' data-action='playTrack' data-recordID='" + data["Track IDs"] + "'>";
          template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 8.64L13.77 12L8.5 15.36V8.64ZM6.5 5V19L17.5 12L6.5 5Z" fill="currentColor"/></svg>';
        template = template + "</button>";

        template = template + "<div class='c-track-result__meta'>";
        template = template + "<p class='c-track-result__track-name'>" + data["Name"] + "</p>";

        template = template + "<div class='c-track-result__meta-links'>";

        if(data["# Tracks"]) {

          template = template + '<p class="c-track-result__artists u-color-maeve-850"><svg class="c-track-result__inline-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>' + data["# Tracks"] + ' tracks</p>';

        }

        if(data["Track Artists"]) {

          template = template + '<p class="c-track-result__artists"><svg class="c-track-result__inline-icon u-color-cryan-500" viewBox="0 0 24 24"><path fill="currentColor" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>' + data["Track Artists"] + '</p>';

        }

        template = template + "</div>";
        template = template + "</div>";

        if(variant !== "noControls") {

          template = template + "<div class='c-track-result__controls'>";

            template = template + "<button type='button' class='c-track-result__button c-track-result__button--addToQueue' data-action='addToQueue' data-recordID='" + data["Track IDs"] + "'>";
              template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z" fill="currentColor"/></svg>';
            template = template + "</button>";
          template = template + "</div>";

        }

      template = template + "</div>";
    template = template + "</li>";

    return template;
  }

  else if (
    component == "playlistItem"
  ) {
    let template = "<li>";
      template = template + "<div class='c-track-result' data-recordid='" + data["Record ID"] + "'>"
        template = template + "<button type='button' class='" + (variant == "noControls" ? 'cursor-default' : '') + " c-track-result__thumbnail thumbnail thumbnail--album' data-thumbnail-recordid='" + data["Track IDs"] + "' loading='lazy' style='background-image: url(" + data["Album Artwork"] + ");' " + (variant == "noControls" ? 'tabindex="-1"' : 'data-action="openCollection"') + "  data-recordID='" + data["Record ID"] + "'></button>";

        template = template + "<button type='button' class='" + (variant == "noControls" ? 'state-invisible' : '') + " c-track-result__button c-track-result__button--play' data-action='playTrack' data-recordID='" + data["Track IDs"] + "'>";
          template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 8.64L13.77 12L8.5 15.36V8.64ZM6.5 5V19L17.5 12L6.5 5Z" fill="currentColor"/></svg>';
        template = template + "</button>";

        template = template + "<div class='c-track-result__meta'>";
        template = template + "<p class='c-track-result__track-name'>" + data["Name"] + "</p>";

        template = template + "<div class='c-track-result__meta-links'>";

        if(data["# Tracks"]) {
        
          template = template + '<p class="c-track-result__artists u-color-maeve-850"><svg class="c-track-result__inline-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>' + data["# Tracks"] + ' tracks</p>';

        }

        if(data["Track Artists"]) {
        
          template = template + '<p class="c-track-result__artists"><svg class="c-track-result__inline-icon u-color-cryan-500" viewBox="0 0 24 24"><path fill="currentColor" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" /></svg>' + data["Track Artists"] + '</p>';

        }

        template = template + "</div>";
        template = template + "</div>";

        if(variant !== "noControls") {

          template = template + "<div class='c-track-result__controls'>";
            
            template = template + "<button type='button' class='c-track-result__button c-track-result__button--addToQueue' data-action='addToQueue' data-recordID='" + data["Track IDs"] + "'>";
              template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z" fill="currentColor"/></svg>';
            template = template + "</button>";
          template = template + "</div>";

        }

      template = template + "</div>";
    template = template + "</li>";

    return template;
  }

  else if (
    component == "artistItem"
  ) {
    let template = "<li>";
      template = template + "<div class='c-track-result c-track-result--album' data-recordid='" + data["Record ID"] + "'>"
        template = template + "<button type='button' class='c-track-result__thumbnail thumbnail thumbnail--album' loading='lazy' style='background-image: url(" + data["Image URL"] + ");' data-action='openArtist' data-recordID='" + data["Record ID"] + "'></button>";

        template = template + "<button type='button' class='c-track-result__button c-track-result__button--play' data-action='playTrack' data-recordID='" + data["All Track IDs"] + "'>";
          template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5 8.64L13.77 12L8.5 15.36V8.64ZM6.5 5V19L17.5 12L6.5 5Z" fill="currentColor"/></svg>';
        template = template + "</button>";

        template = template + "<div class='c-track-result__meta'>";
        template = template + "<p class='c-track-result__track-name'>" + data["Display Name"] + "</p>";

        template = template + "<div class='c-track-result__meta-links'>";

        if(data["# Albums"]) {
          template = template + '<p class="c-track-result__artists u-color-maeve-850"><svg class="c-track-result__inline-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>' + data["# Albums"] + (data["# Albums"] === 1 ? ' album' : ' albums') + '</p>';
        }

        if(data["# Total Tracks"]) {
          template = template + '<p class="c-track-result__artists u-color-maeve-850"><svg class="c-track-result__inline-icon" viewBox="0 0 24 24"><path fill="currentColor" d="M12,11A1,1 0 0,0 11,12A1,1 0 0,0 12,13A1,1 0 0,0 13,12A1,1 0 0,0 12,11M12,16.5C9.5,16.5 7.5,14.5 7.5,12C7.5,9.5 9.5,7.5 12,7.5C14.5,7.5 16.5,9.5 16.5,12C16.5,14.5 14.5,16.5 12,16.5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>' + data["# Total Tracks"] + (data["# Total Tracks"] === 1 ? ' track' : ' tracks') + '</p>';
        }

        template = template + "</div>";
        template = template + "</div>";

        template = template + "<div class='c-track-result__controls'>";
          template = template + "<button type='button' class='c-track-result__button c-track-result__button--addToQueue' data-action='addToQueue' data-recordID='" + data["All Track IDs"] + "'>";
            template = template + '<svg class="c-track-result__button-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 9H2.5V11H13.5V9ZM13.5 5H2.5V7H13.5V5ZM17.5 13V9H15.5V13H11.5V15H15.5V19H17.5V15H21.5V13H17.5ZM2.5 15H9.5V13H2.5V15Z" fill="currentColor"/></svg>';
          template = template + "</button>";
        template = template + "</div>";

      template = template + "</div>";
    template = template + "</li>";

    return template;
  }

}

Airwaves.searchAirtable = function searchAirtable(searchTerm) {

  // console.log('searching for "' + searchTerm + '"');

  var cleanedSearchTerm = searchTerm.replace(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g, ' ').replace(/ {2,}/g, ' ');

  document.getElementById('searchResults').innerHTML = "";

  document.getElementById('searchResults').classList.add("is-loading");

  console.log("Searched for: " + searchTerm);
  console.log("Searched for (cleaned): " + cleanedSearchTerm);

  var searchResultTracks = [];

  base('Tracks')
    .select({
      view: "🔍 Has Artist",
      filterByFormula: 'OR(FIND(LOWER("' + cleanedSearchTerm + '"), {Search Terms})>0)',
      fields: tracksFieldsQuery
    })
    .eachPage(function page(records, fetchNextPage) {

      records.forEach(function (record) {

        console.log(record);

        var track = [];
        track["Title"] = "";
        track["Record ID"] = "";
        track["Play URL"] = "";
        track["Track Name"] = "";
        track["Track Type"] = "";
        track["Artists"] = "";
        track["Featured Artists"] = "";
        track["Remix Artists"] = "";
        track["Album"] = "";
        track["Album Artwork URL"] = "";

        if (tracksColumns["title"] in record.fields) {
          track["Title"] = record.get(tracksColumns["title"]);
        }

        if (tracksColumns["recordID"] in record.fields) {
          track["Record ID"] = record.get(tracksColumns["recordID"]);
        }

        if (tracksColumns["trackFile"] in record.fields) {
          track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
        } else {
          if(tracksColumns["googleDriveURL"] in record.fields)
          track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
        }

        if (tracksColumns["trackName"] in record.fields) {
          track["Track Name"] = record.get(tracksColumns["trackName"]);
        }

        if (tracksColumns["trackType"] in record.fields) {
          track["Track Type"] = record.get(tracksColumns["trackType"]);
        }

        if (tracksColumns["artists"] in record.fields) {
          track["Artists"] = record.get(tracksColumns["artists"]);
        }

        if (tracksColumns["featuredArtists"] in record.fields) {
          track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
        }

        if (tracksColumns["remixArtists"] in record.fields) {
          track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
        }

        if (tracksColumns["album"] in record.fields) {
          track["Album"] = record.get(tracksColumns["album"]);
        }
        if (tracksColumns["artistIDs"] in record.fields) {
          track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
        }
        if (tracksColumns["featuredArtistIDs"] in record.fields) {
          track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
        }
        if (tracksColumns["remixArtistIDs"] in record.fields) {
          track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
        }
        if (tracksColumns["artistNamesLookup"] in record.fields) {
          track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
        }
        if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
          track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
        }
        if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
          track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
        }
        if (tracksColumns["albumID"] in record.fields) {
          track["Album ID"] = record.get(tracksColumns["albumID"]);
        }
        if (tracksColumns["playlists"] in record.fields) {
          track["Playlists"] = record.get(tracksColumns["playlists"]);
        }

        if (tracksColumns["albumArtwork"] in record.fields) {
          if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
            if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
            } else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
            }
          } else {
            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
          }
        }

        Airwaves.trackCache.push(track);

        var trackItemTemplate = componentTemplate("trackItem", "", track);

        searchResultTracks.push(trackItemTemplate);
      });

      fetchNextPage();

    }, function done(err) {

      document.getElementById('searchResults').classList.remove("is-loading");

      if (err) {
        console.error(err);
        document.getElementById('searchResults').innerHTML = "<p style='position: absolute; top: 50%; left: 50%; white-space: nowrap; transform: translate(-50%);'><span style='font-size: 3em;'>🤷‍♂️</span> Error fetching tracks</p>";
        return;
      }

      if (searchResultTracks.length > 0) {
        document.getElementById('searchResults').innerHTML = "<ul class='results__list results__list--grid'>" + searchResultTracks.join("") + "</ul>";
      } else {
        document.getElementById('searchResults').innerHTML = "<p style='position: absolute; top: 50%; left: 50%; white-space: nowrap; transform: translate(-50%);'><span style='font-size: 3em;'>🤷‍♂️</span> No matching tracks</p>";
      }

    });

}


Airwaves.search = function search(e) {

  var input = document.getElementById('input').value;
  Airwaves.searchAirtable(input);

}

Airwaves.searchInput.addEventListener('focus', (event) => {
  document.body.classList.add("is-focused-search-input");
});

Airwaves.searchInput.addEventListener('blur', (event) => {
  document.body.classList.remove("is-focused-search-input");
});

Airwaves.removeFromQueue = function removeFromQueue(recordID) {

  for (var i = Airwaves.queueFuture.length - 1; i >= 0; --i) {

    // console.log("item in queueFuture:");
    // console.log(Airwaves.queueFuture[i]["Record ID"]);

    if (Airwaves.queueFuture[i]["Record ID"] == recordID) {
      Airwaves.queueFuture.splice(i, 1);
    }
  }

  renderQueueFuture();

}

Airwaves.clearQueue = function clearQueue() {

  Airwaves.sendAlert('Cleared upcoming queue');
  
  Airwaves.queueFuture = [];
  renderQueueFuture();
}

Airwaves.shuffleQueue = function shuffleQueue() {

  Airwaves.sendAlert('Shuffling upcoming queue');

  let currentQueueFuture = Airwaves.queueFuture;
  
  console.log("Current queue");
  console.log(currentQueueFuture);

  let shuffledQueueFuture = currentQueueFuture.sort(() => Math.random() - 0.5);

  console.log("Shuffled queue");
  console.log(shuffledQueueFuture);
  
  Airwaves.queueFuture = shuffledQueueFuture;
  renderQueueFuture();
}

Airwaves.sendAlert = function sendAlert(text) {
  
  // remove 'open' attr to fadeout
  Airwaves.alert.removeAttribute('open');

  // remove innerHMTL after fadeout
  document.getElementById("alertText").innerHTML = "";

  // use text as new innerHTML
  document.getElementById("alertText").innerHTML = text;

  // add 'open' attr to fadein
  Airwaves.alert.setAttribute('open', "");

  // after X delay, remove 'open' attr to fadeout
  setTimeout(function(){
    Airwaves.alert.removeAttribute('open');
  }, 5000);
}


// Build a shareable deep-link URL for a track/album/playlist/artist and copy it
// to the clipboard. The type maps to the query params the loader understands.
Airwaves.buildShareURL = function buildShareURL(type, recordID) {
  return window.location.origin + window.location.pathname + '?' + type + '=' + encodeURIComponent(recordID);
};

Airwaves.copyShareLink = function copyShareLink(type, recordID) {
  if (!recordID) {
    Airwaves.sendAlert('Nothing to share yet');
    return;
  }
  var link = Airwaves.buildShareURL(type, recordID);
  var done = function () { Airwaves.sendAlert('Link copied to clipboard'); };
  var fail = function () {
    // Fallback for browsers without async clipboard access.
    var temp = document.createElement('textarea');
    temp.value = link;
    temp.setAttribute('readonly', '');
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    temp.select();
    try { document.execCommand('copy'); Airwaves.sendAlert('Link copied to clipboard'); }
    catch (e) { Airwaves.sendAlert('Could not copy link'); }
    document.body.removeChild(temp);
  };

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(link).then(done).catch(fail);
  } else {
    fail();
  }
};

// Markup for a "Copy link" share button (chain-link icon + label).
Airwaves.shareButtonHTML = function shareButtonHTML(type, recordID) {
  return "<button type='button' class='c-share-button' data-action='copyShareLink' data-share-type='" + type + "'" +
    (recordID ? " data-recordID='" + recordID + "'" : "") + ">" +
    "<svg class='c-share-button__icon' viewBox='0 0 24 24' aria-hidden='true'>" +
    "<path fill='currentColor' d='M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z'/></svg>" +
    "<span class='c-share-button__label'>Copy link</span></button>";
};


function reloadAudio(track) {
  
  console.log(track);

  Airwaves.sendAlert('Now playing: ' +  track["Track Name"]);

  document.getElementById('player').classList.add("is-hidden");

  // Stream through our proxy by track id so the Drive URL is never exposed and
  // seeking still works (the edge function forwards Range headers). Fall back to
  // the direct Play URL only if we somehow lack a record id.
  var streamSrc = track["Record ID"]
    ? (window.location.origin + '/stream?track=' + encodeURIComponent(track["Record ID"]))
    : track["Play URL"];
  // Set the source directly on the element rather than juggling <source>
  // children. With a `src` attribute present the browser ignores any <source>
  // children, so this sidesteps the old bug where a leftover placeholder
  // <source src="#"> sat first in the list — the resource selector would try
  // to load the page HTML as audio, fail, and often stall in NETWORK_NO_SOURCE
  // ("play, but no sound").
  Airwaves.audio.src = streamSrc;
  Airwaves.audio.load();
  playAudio();

  if (Airwaves.waveform) Airwaves.waveform.load(track);

  document.querySelector('.playPause').classList.remove('paused');

  document.title = track["Title"] + " - Airwaves";

  setTimeout(() => {
    if(
      track["Album Artwork URL"] !== undefined
    ) 
    {
      document.getElementById("currentAlbumArtwork").style.backgroundImage = "url('" + track["Album Artwork URL"] + "')";
    }
    else {
      document.getElementById("currentAlbumArtwork").style.backgroundImage = "";
    }

    document.getElementById("currentArtists").innerHTML = track["Artists"];
    document.getElementById("currentTrack").innerHTML = track["Track Name"];
    document.getElementById("currentAlbum").innerHTML = track["Album"];

    document.getElementById('player').classList.remove("is-hidden");
    document.getElementById('player').classList.remove("is-track-detail-open");
    Airwaves.populateTrackDetail();

    let styleThumbnail = document.getElementById('style-thumbnail');
    styleThumbnail?.remove();
    
    document.head.insertAdjacentHTML("beforeend", `<style id='style-thumbnail'>[data-thumbnail-recordid='` + track["Record ID"]  + `'] { animation: playingThumbnail 2.91s linear infinite; } </style>`)
  }, "200");


  // Move the track we're leaving into history — unless we're navigating
  // backwards via the previous button, in which case it goes to the FRONT of
  // the future queue so pressing "next" returns to it.
  if (Airwaves.queueCurrent["Record ID"]) {
    if (Airwaves._navBack) {
      Airwaves.queueFuture.unshift(Airwaves.queueCurrent);
    } else {
      Airwaves.queuePast.push(Airwaves.queueCurrent);
    }
  }
  Airwaves._navBack = false;

  // console.log("Airwaves.queuePast:");
  // console.table(Airwaves.queuePast);

  renderQueuePast();

  // reset, then set queueCurrent
  Airwaves.queueCurrent = [];
  Airwaves.queueCurrent["Record ID"] = track["Record ID"];
  Airwaves.queueCurrent["Track Name"] = track["Track Name"];
  Airwaves.queueCurrent["Artists"] = track["Artists"];
  Airwaves.queueCurrent["Featured Artists"] = track["Featured Artists"];
  Airwaves.queueCurrent["Remix Artists"] = track["Remix Artists"];
  Airwaves.queueCurrent["Track Type"] = track["Track Type"];
  Airwaves.queueCurrent["Album"] = track["Album"];
  Airwaves.queueCurrent["Album Artwork URL"] = track["Album Artwork URL"];
  Airwaves.queueCurrent["Artist IDs"] = track["Artist IDs"];
  Airwaves.queueCurrent["Featured Artist IDs"] = track["Featured Artist IDs"];
  Airwaves.queueCurrent["Remix Artist IDs"] = track["Remix Artist IDs"];
  Airwaves.queueCurrent["Artist Names Lookup"] = track["Artist Names Lookup"];
  Airwaves.queueCurrent["Featured Artist Names Lookup"] = track["Featured Artist Names Lookup"];
  Airwaves.queueCurrent["Remix Artist Names Lookup"] = track["Remix Artist Names Lookup"];
  Airwaves.queueCurrent["Album ID"] = track["Album ID"];
  Airwaves.queueCurrent["Playlists"] = track["Playlists"];

  // console.log("Airwaves.queueCurrent:");
  // console.table(Airwaves.queueCurrent);

  if ('mediaSession' in navigator) {

    navigator.mediaSession.metadata = new MediaMetadata({
      title: track["Track Name"],
      artist: track["Artists"],
      album: track["Album"],
      artwork: [
        { src: track["Album Artwork URL"], type: 'image/png' },
      ]
    });
  
    navigator.mediaSession.setActionHandler('play', Airwaves.playPause);
    navigator.mediaSession.setActionHandler('pause', Airwaves.playPause);
    navigator.mediaSession.setActionHandler('seekbackward', Airwaves.seekBackward);
    navigator.mediaSession.setActionHandler('seekforward', Airwaves.seekForward);
    navigator.mediaSession.setActionHandler('nexttrack', Airwaves.skipTrack);
    navigator.mediaSession.setActionHandler('previoustrack', Airwaves.previousTrack);
  }

  renderQueueCurrent();

  if(Airwaves.queueFuture.length < 1) {
    populateQueueFuture();
  }

  Airwaves.removeFromQueue(track["Record ID"]);
}

Airwaves.play = function play(recordIDs, callback) {

  let recordToPlay = "";
  let recordsToAddToQueue = "";

  // console.log(recordIDs);

  if (recordIDs.includes(',')) {

    // console.log('recordIDs:');
    // console.log(recordIDs);
    
    // it's a list, push each one to the array
    recordIDs = recordIDs.split(',');

    // console.log('recordIDs after split:');
    // console.log(recordIDs);

    recordToPlay = recordIDs.slice(0,1);

    // console.log('recordToPlay:');
    // console.log(recordToPlay);
  
    recordsToAddToQueue = recordIDs.slice(1,recordIDs.length);

    // console.log('recordsToAddToQueue');
    // console.log(recordsToAddToQueue);

    // console.log('recordsToAddToQueue toString():');
    // console.log(recordsToAddToQueue.toString());

    Airwaves.addToQueue(recordsToAddToQueue.toString());
    
  } else {
    recordToPlay = recordIDs;
  }

  var track = [];
  track["Record ID"] = "";
  track["Play URL"] = "";
  track["Track Name"] = "";
  track["Track Type"] = "";
  track["Artists"] = "";
  track["Featured Artists"] = "";
  track["Remix Artists"] = "";
  track["Album"] = "";
  track["Album Artwork URL"] = "";

  var cachedTrack = Airwaves.trackCache.find(track => track["Record ID"] === recordToPlay);
  
  if(
    cachedTrack
  ) 
  { 
    console.log("Found cached track:");
    console.log(cachedTrack);

    track["Title"] = cachedTrack["Title"];
    track["Play URL"] = cachedTrack["Play URL"];
    track["Record ID"] = cachedTrack["Record ID"];
    track["Track Name"] = cachedTrack["Track Name"];
    track["Track Type"] = cachedTrack["Track Type"];
    track["Artists"] = cachedTrack["Artists"];
    track["Featured Artists"] = cachedTrack["Featured Artists"];
    track["Remix Artists"] = cachedTrack["Remix Artists"];
    track["Album"] = cachedTrack["Album"];
    track["Album Artwork URL"] = cachedTrack["Album Artwork URL"];
    track["Artist IDs"] = cachedTrack["Artist IDs"];
    track["Featured Artist IDs"] = cachedTrack["Featured Artist IDs"];
    track["Remix Artist IDs"] = cachedTrack["Remix Artist IDs"];
    track["Artist Names Lookup"] = cachedTrack["Artist Names Lookup"];
    track["Featured Artist Names Lookup"] = cachedTrack["Featured Artist Names Lookup"];
    track["Remix Artist Names Lookup"] = cachedTrack["Remix Artist Names Lookup"];
    track["Album ID"] = cachedTrack["Album ID"];
    track["Playlists"] = cachedTrack["Playlists"];

    reloadAudio(track);
  }

  else {

    console.log("No cached track, go get " + recordToPlay);

    base('Tracks').find(recordToPlay).then(record => {

      if (record.fields[tracksColumns["title"]]) {
        track["Title"] = record.fields[tracksColumns["title"]];
      }

      if (record.fields[tracksColumns["recordID"]]) {
        track["Record ID"] = record.fields[tracksColumns["recordID"]];
      }
      
      // ["Play URL"]
      // Play URL = Track File [url] OR Google Drive URL
      if (tracksColumns["trackFile"] in record.fields) {
        // console.log("found trackfile in Airtable!");
        track["Play URL"] = record.fields[tracksColumns["trackFile"]][0].url;
      } else {
        if(tracksColumns["googleDriveURL"] in record.fields)
        // console.log("found google drive trackfile!");
        track["Play URL"] = record.fields[tracksColumns["googleDriveURL"]];
      }

      if (record.fields[tracksColumns["trackNamePlus"]]) {
        track["Track Name"] = record.fields[tracksColumns["trackNamePlus"]];
      }

      if (record.fields[tracksColumns["trackType"]]) {
        track["Track Type"] = record.fields[tracksColumns["trackType"]];
      }

      if (record.fields[tracksColumns["artists"]]) {
        track["Artists"] = record.fields[tracksColumns["artists"]];
      }

      if (record.fields[tracksColumns["featuredArtists"]]) {
        track["Featured Artists"] = record.fields[tracksColumns["featuredArtists"]];
      }

      if (record.fields[tracksColumns["remixArtists"]]) {
        track["Remix Artists"] = record.fields[tracksColumns["remixArtists"]];
      }

      if (record.fields[tracksColumns["album"]]) {
        track["Album"] = record.fields[tracksColumns["album"]];
      }
      if (record.fields[tracksColumns["artistIDs"]]) {
        track["Artist IDs"] = record.fields[tracksColumns["artistIDs"]];
      }
      if (record.fields[tracksColumns["featuredArtistIDs"]]) {
        track["Featured Artist IDs"] = record.fields[tracksColumns["featuredArtistIDs"]];
      }
      if (record.fields[tracksColumns["remixArtistIDs"]]) {
        track["Remix Artist IDs"] = record.fields[tracksColumns["remixArtistIDs"]];
      }
      if (record.fields[tracksColumns["artistNamesLookup"]]) {
        track["Artist Names Lookup"] = record.fields[tracksColumns["artistNamesLookup"]];
      }
      if (record.fields[tracksColumns["featuredArtistNamesLookup"]]) {
        track["Featured Artist Names Lookup"] = record.fields[tracksColumns["featuredArtistNamesLookup"]];
      }
      if (record.fields[tracksColumns["remixArtistNamesLookup"]]) {
        track["Remix Artist Names Lookup"] = record.fields[tracksColumns["remixArtistNamesLookup"]];
      }
      if (record.fields[tracksColumns["albumID"]]) {
        track["Album ID"] = record.fields[tracksColumns["albumID"]];
      }
      if (record.fields[tracksColumns["playlists"]]) {
        track["Playlists"] = record.fields[tracksColumns["playlists"]];
      }

      if (record.fields[tracksColumns["albumArtwork"]]) {
        track["Album Artwork URL"] = record.fields[tracksColumns["albumArtwork"]][0].thumbnails.large.url;
      }

      reloadAudio(track);

    }).catch(err => {
      console.error(err); return;
    })

  }

}

function getTotalTracks() {

  base('All').find('recgZBgzmxBui4cZI', function(err, record) {
    if (err) { console.error(err); return; }

    // console.log('Retrieved', record.id);
    // console.log('Retrieved', record.fields["Total"]);

    Airwaves.totalTracks = record.fields["Total"];

  });

}

getTotalTracks();



// Deep links from a shared URL: ?track= / ?album= / ?playlist= / ?artist=
var url_string = window.location.href
var url = new URL(url_string);
var url_track = url.searchParams.get("track");
var url_album = url.searchParams.get("album");
var url_playlist = url.searchParams.get("playlist");
var url_artist = url.searchParams.get("artist");

// View deep-links need Alpine ($data) initialised before we switch panels.
function whenAlpineReady(callback) {
  if (document.body.__x && document.body.__x.$data) { callback(); return; }
  var tries = 0;
  var timer = setInterval(function () {
    if ((document.body.__x && document.body.__x.$data) || tries++ > 100) {
      clearInterval(timer);
      if (document.body.__x && document.body.__x.$data) callback();
    }
  }, 50);
}

function openLibraryView(opener) {
  whenAlpineReady(function () {
    document.querySelector('.player').classList.remove('is-track-detail-open');
    document.body.__x.$data.selected = 'content-new';
    opener();
  });
}

// Deferred to load so every opener (defined later in this file) exists and
// Alpine has initialised before we dispatch.
window.addEventListener('load', function () {
  if (url_track) {
    Airwaves.play(url_track);
  } else if (url_album) {
    openLibraryView(function () { Airwaves.openCollectionById(url_album, 'album'); });
  } else if (url_playlist) {
    openLibraryView(function () { Airwaves.openCollectionById(url_playlist, 'playlist'); });
  } else if (url_artist) {
    openLibraryView(function () { Airwaves.openArtist(url_artist); });
  }
});

document.onkeydown = function (e) {
  e = e || window.event;
  var key = e.which || e.keyCode;
  if (key === 32) {
    // check if an input is currently in focus
    if (
      document.activeElement.nodeName.toLowerCase() != "input" &&
      document.activeElement.nodeName.toLowerCase() != "audio"
    ) {

      // console.log('Hijacking spacebar for playPause toggle');

      // prevent default spacebar event (scrolling to bottom)
      e.preventDefault();

      Airwaves.playPause();
    }
  }
}



Airwaves.listNewTracks = function listNewTracks() {

  Airwaves.sendAlert('Refreshing new tracks');

  document.getElementById('newTracksResults').innerHTML = "";
  document.getElementById('newTracksResults').classList.add("is-loading");

  // console.log(columns);

  base('Tracks')
    .select({
      view: "⬇️ Recently Created",
      fields: tracksFieldsQuery
    })
    .firstPage(function (err, records) {

      if (err) { console.error(err); return; }

      var newTracks = [];

      records.forEach(function (record) {

        // console.log(record);

        var track = [];
        track["Title"] = "";
        track["Record ID"] = "";
        track["Play URL"] = "";
        track["Track Name"] = "";
        track["Track Type"] = "";
        track["Artists"] = "";
        track["Featured Artists"] = "";
        track["Remix Artists"] = "";
        track["Album"] = "";
        track["Album Artwork URL"] = "";

        if (tracksColumns["title"] in record.fields) {
          track["Title"] = record.get(tracksColumns["title"]);
        }

        if (tracksColumns["recordID"] in record.fields) {
          track["Record ID"] = record.get(tracksColumns["recordID"]);
        }

        // ["Play URL"]
        // Play URL = Track File [url] OR Google Drive URL
        if (tracksColumns["trackFile"] in record.fields) {
          // console.log("found trackfile in Airtable!");
          track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
        } else {
          if(tracksColumns["googleDriveURL"] in record.fields)
          // console.log("found google drive trackfile!");
          track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
        }

        if (tracksColumns["trackName"] in record.fields) {
          track["Track Name"] = record.get(tracksColumns["trackName"]);
        }

        if (tracksColumns["trackType"] in record.fields) {
          track["Track Type"] = record.get(tracksColumns["trackType"]);
        }

        if (tracksColumns["artists"] in record.fields) {
          track["Artists"] = record.get(tracksColumns["artists"]);
        }

        if (tracksColumns["featuredArtists"] in record.fields) {
          track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
        }

        if (tracksColumns["remixArtists"] in record.fields) {
          track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
        }

        if (tracksColumns["album"] in record.fields) {
          track["Album"] = record.get(tracksColumns["album"]);
        }
        if (tracksColumns["artistIDs"] in record.fields) {
          track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
        }
        if (tracksColumns["featuredArtistIDs"] in record.fields) {
          track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
        }
        if (tracksColumns["remixArtistIDs"] in record.fields) {
          track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
        }
        if (tracksColumns["artistNamesLookup"] in record.fields) {
          track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
        }
        if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
          track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
        }
        if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
          track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
        }
        if (tracksColumns["albumID"] in record.fields) {
          track["Album ID"] = record.get(tracksColumns["albumID"]);
        }
        if (tracksColumns["playlists"] in record.fields) {
          track["Playlists"] = record.get(tracksColumns["playlists"]);
        }

        if (tracksColumns["albumArtwork"] in record.fields) {

          if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {

            if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
            }

            else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
            }
          }
          else {
            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
          }
        }

        Airwaves.trackCache.push(track);

        var trackItemTemplate = componentTemplate("trackItem", "", track);

        newTracks.push(trackItemTemplate);

      });

      document.getElementById('newTracksResults').classList.remove("is-loading");

      document.getElementById('newTracksResults').innerHTML = "<ul class='results__list results__list--grid'>" + newTracks.join("") + "</ul>";

    });

}

Airwaves.listNewTracks();

Airwaves.listNewPlaylists = function listNewPlaylists() {

  Airwaves.sendAlert('Refreshing new playlists');

  Airwaves.collectionCache = Airwaves.collectionCache.filter(c => c["Type"] !== "playlist");

  document.getElementById('newPlaylistsResults').innerHTML = "";
  document.getElementById('newPlaylistsResults').classList.add("is-loading");

  base('Playlists')
    .select({
      view: "📖 All Playlists",
      fields: playlistsFieldsQuery
    })
    .firstPage(function (err, records) {

      if (err) { console.error(err); return; }

      var newPlaylists = [];

      records.forEach(function (record) {

        var playlist = [];
        playlist["Name"] = "";
        playlist["Record ID"] = "";
        playlist["Track Artists"] = "";
        playlist["Track IDs"] = "";
        playlist["# Tracks"] = "";
        playlist["Album Artwork"] = "";

        if (playlistsColumns["name"] in record.fields) {
          playlist["Name"] = record.get(playlistsColumns["name"]);
        }

        if (playlistsColumns["recordID"] in record.fields) {
          playlist["Record ID"] = record.get(playlistsColumns["recordID"]);
        }

        if (playlistsColumns["trackArtists"] in record.fields) {
          // playlist["Track Artists"] = record.get(playlistsColumns["trackArtists"]);
          playlist["Track Artists"] = [...new Set(record.get(playlistsColumns["trackArtists"]).split(', '))].join(', ');
        }

        if (playlistsColumns["trackIDs"] in record.fields) {
          playlist["Track IDs"] = record.get(playlistsColumns["trackIDs"]);
        }

        if (playlistsColumns["trackCount"] in record.fields) {
          playlist["# Tracks"] = record.get(playlistsColumns["trackCount"]);
        }

        if (playlistsColumns["tracksAlbumArtworks"] in record.fields) {
          // console.log(record.get(playlistsColumns["tracksAlbumArtworks"]));

          var firstArtworkInLookup = record.get(playlistsColumns["tracksAlbumArtworks"])[0];

          if("thumbnails" in firstArtworkInLookup) {

            if("large" in firstArtworkInLookup.thumbnails) {
              playlist["Album Artwork"] = firstArtworkInLookup.thumbnails.large.url;
            }

            else if("small" in firstArtworkInLookup.thumbnails) {
              playlist["Album Artwork"] = firstArtworkInLookup.thumbnails.small.url;
            }
          }
          else {
            playlist["Album Artwork"] = firstArtworkInLookup.url;
          }
        }

        playlist["Type"] = "playlist";
        Airwaves.collectionCache.push(playlist);

        var playlistItemTemplate = componentTemplate("playlistItem", "", playlist);

        newPlaylists.push(playlistItemTemplate);

      });

      document.getElementById('newPlaylistsResults').classList.remove("is-loading");

      document.getElementById('newPlaylistsResults').innerHTML = "<ul class='results__list results__list--grid'>" + newPlaylists.join("") + "</ul>";

    });

}

Airwaves.listNewPlaylists();

Airwaves.listNewAlbums = function listNewAlbums() {

  Airwaves.sendAlert('Refreshing new albums');

  Airwaves.collectionCache = Airwaves.collectionCache.filter(c => c["Type"] !== "album");

  document.getElementById('newAlbumsResults').innerHTML = "";
  document.getElementById('newAlbumsResults').classList.add("is-loading");

  base('Albums')
    .select({
      view: "⬇️ Recently Created",
      fields: albumsFieldsQuery
    })
    .firstPage(function (err, records) {

      if (err) { console.error(err); return; }

      var newAlbums = [];

      records.forEach(function (record) {

        var album = [];
        album["Name"] = "";
        album["Record ID"] = "";
        album["Track Artists"] = "";
        album["Track IDs"] = "";
        album["Track Types"] = "";
        album["# Tracks"] = "";
        album["Album Artwork"] = "";

        if (albumsColumns["name"] in record.fields) {
          album["Name"] = record.get(albumsColumns["name"]);
        }

        if (albumsColumns["recordID"] in record.fields) {
          album["Record ID"] = record.get(albumsColumns["recordID"]);
        }

        if (albumsColumns["trackArtists"] in record.fields) {
          // album["Track Artists"] = record.get(albumsColumns["trackArtists"]);
          album["Track Artists"] = [...new Set(record.get(albumsColumns["trackArtists"]).split(', '))].join(', ');
        }

        if (albumsColumns["trackIDs"] in record.fields) {
          album["Track IDs"] = record.get(albumsColumns["trackIDs"]);
        }

        if (albumsColumns["trackTypes"] in record.fields) {
          album["Track Types"] = record.get(albumsColumns["trackTypes"]);
        }

        if (albumsColumns["trackCount"] in record.fields) {
          album["# Tracks"] = record.get(albumsColumns["trackCount"]);
        }

        if (albumsColumns["tracksAlbumArtworks"] in record.fields) {
          // console.log(record.get(albumsColumns["tracksAlbumArtworks"]));

          var firstArtworkInLookup = record.get(albumsColumns["tracksAlbumArtworks"])[0];

          if("thumbnails" in firstArtworkInLookup) {

            if("large" in firstArtworkInLookup.thumbnails) {
              album["Album Artwork"] = firstArtworkInLookup.thumbnails.large.url;
            }

            else if("small" in firstArtworkInLookup.thumbnails) {
              album["Album Artwork"] = firstArtworkInLookup.thumbnails.small.url;
            }
          }
          else {
            album["Album Artwork"] = firstArtworkInLookup.url;
          }
        }

        album["Type"] = "album";
        Airwaves.collectionCache.push(album);

        var albumItemTemplate = componentTemplate("albumItem", "", album);

        newAlbums.push(albumItemTemplate);

      });

      document.getElementById('newAlbumsResults').classList.remove("is-loading");

      document.getElementById('newAlbumsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + newAlbums.join("") + "</ul>";

    });

}

Airwaves.listNewAlbums();

Airwaves.listAlbumsByCluster = function listAlbumsByCluster(clusterKey, letters) {

  Airwaves.currentAlbumCluster = clusterKey;

  // Update active cluster button
  document.querySelectorAll('.c-album-cluster').forEach(function(btn) {
    btn.classList.toggle('active', btn.dataset.cluster === clusterKey);
  });

  // "Recent" uses the existing listNewAlbums function
  if (clusterKey === 'Recent') {
    Airwaves.listNewAlbums();
    return;
  }

  // Serve from cache if already fetched
  if (Airwaves.albumClusterCache[clusterKey]) {
    var cached = Airwaves.albumClusterCache[clusterKey];
    var albumCards = cached.map(function(album) {
      return componentTemplate("albumItem", "", album);
    });
    document.getElementById('newAlbumsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + albumCards.join("") + "</ul>";
    return;
  }

  document.getElementById('newAlbumsResults').innerHTML = "";
  document.getElementById('newAlbumsResults').classList.add("is-loading");

  var formula = "OR(" + letters.map(function(l) {
    return isNaN(l)
      ? "LEFT(UPPER({Name}), 1) = '" + l + "'"
      : "LEFT({Name}, 1) = '" + l + "'";
  }).join(",") + ")";

  var clusterAlbums = [];

  base('Albums')
    .select({
      sort: [{ field: 'Name', direction: 'asc' }],
      filterByFormula: formula,
      fields: albumsFieldsQuery
    })
    .eachPage(function page(records, fetchNextPage) {

      records.forEach(function(record) {

        var album = [];
        album["Name"] = "";
        album["Record ID"] = "";
        album["Track Artists"] = "";
        album["Track IDs"] = "";
        album["Track Types"] = "";
        album["# Tracks"] = "";
        album["Album Artwork"] = "";

        if (albumsColumns["name"] in record.fields) {
          album["Name"] = record.get(albumsColumns["name"]);
        }
        if (albumsColumns["recordID"] in record.fields) {
          album["Record ID"] = record.get(albumsColumns["recordID"]);
        }
        if (albumsColumns["trackArtists"] in record.fields) {
          album["Track Artists"] = [...new Set(record.get(albumsColumns["trackArtists"]).split(', '))].join(', ');
        }
        if (albumsColumns["trackIDs"] in record.fields) {
          album["Track IDs"] = record.get(albumsColumns["trackIDs"]);
        }
        if (albumsColumns["trackTypes"] in record.fields) {
          album["Track Types"] = record.get(albumsColumns["trackTypes"]);
        }
        if (albumsColumns["trackCount"] in record.fields) {
          album["# Tracks"] = record.get(albumsColumns["trackCount"]);
        }
        if (albumsColumns["tracksAlbumArtworks"] in record.fields) {
          var firstArtwork = record.get(albumsColumns["tracksAlbumArtworks"])[0];
          if ("thumbnails" in firstArtwork) {
            if ("large" in firstArtwork.thumbnails) {
              album["Album Artwork"] = firstArtwork.thumbnails.large.url;
            } else if ("small" in firstArtwork.thumbnails) {
              album["Album Artwork"] = firstArtwork.thumbnails.small.url;
            }
          } else {
            album["Album Artwork"] = firstArtwork.url;
          }
        }

        album["Type"] = "album";
        // Add to collectionCache for openCollection lookups (avoid duplicates)
        if (!Airwaves.collectionCache.find(function(c) { return c["Record ID"] === album["Record ID"]; })) {
          Airwaves.collectionCache.push(album);
        }

        clusterAlbums.push(album);
      });

      fetchNextPage();

    }, function done(err) {

      document.getElementById('newAlbumsResults').classList.remove("is-loading");
      if (err) { console.error(err); return; }

      Airwaves.albumClusterCache[clusterKey] = clusterAlbums;

      var albumCards = clusterAlbums.map(function(album) {
        return componentTemplate("albumItem", "", album);
      });

      document.getElementById('newAlbumsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + albumCards.join("") + "</ul>";

    });
};

Airwaves.listArtists = function listArtists() {

  Airwaves.sendAlert('Refreshing artists');

  Airwaves.artistCache = [];

  document.getElementById('newArtistsResults').innerHTML = "";
  document.getElementById('newArtistsResults').classList.add("is-loading");

  var artistCards = [];

  base('Artists')
    .select({
      sort: [{field: 'Display Name', direction: 'asc'}],
      fields: artistsFieldsQuery
    })
    .eachPage(function page(records, fetchNextPage) {

      records.forEach(function (record) {

        var artist = [];
        artist["Display Name"] = "";
        artist["Record ID"] = "";
        artist["Image URL"] = "";
        artist["All Track IDs"] = "";
        artist["Track IDs (Main Artist)"] = "";
        artist["# Total Tracks"] = 0;
        artist["# Albums"] = 0;
        artist["Track Albums"] = "";
        artist["Track Albums Record IDs"] = "";

        if (artistsColumns["displayName"] in record.fields) {
          artist["Display Name"] = record.get(artistsColumns["displayName"]);
        }

        if (artistsColumns["recordID"] in record.fields) {
          artist["Record ID"] = record.get(artistsColumns["recordID"]);
        }

        if (artistsColumns["imageURL"] in record.fields) {
          artist["Image URL"] = record.get(artistsColumns["imageURL"]);
        }

        if (artistsColumns["allTrackIDs"] in record.fields) {
          artist["All Track IDs"] = record.get(artistsColumns["allTrackIDs"]);
        }

        if (artistsColumns["trackIDsMainArtist"] in record.fields) {
          artist["Track IDs (Main Artist)"] = record.get(artistsColumns["trackIDsMainArtist"]);
        }

        if (artistsColumns["totalTracks"] in record.fields) {
          artist["# Total Tracks"] = record.get(artistsColumns["totalTracks"]);
        }

        if (artistsColumns["totalAlbums"] in record.fields) {
          artist["# Albums"] = record.get(artistsColumns["totalAlbums"]);
        }

        if (artistsColumns["trackAlbums"] in record.fields) {
          artist["Track Albums"] = record.get(artistsColumns["trackAlbums"]);
        }

        if (artistsColumns["trackAlbumsRecordIDs"] in record.fields) {
          artist["Track Albums Record IDs"] = record.get(artistsColumns["trackAlbumsRecordIDs"]);
        }

        Airwaves.artistCache.push(artist);

        var artistItemTemplate = componentTemplate("artistItem", "", artist);

        artistCards.push(artistItemTemplate);

      });

      fetchNextPage();

    }, function done(err) {

      document.getElementById('newArtistsResults').classList.remove("is-loading");

      if (err) { console.error(err); return; }

      document.getElementById('newArtistsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + artistCards.join("") + "</ul>";

    });

}

// On startup load the first cluster only
Airwaves.listArtistsByCluster = function listArtistsByCluster(clusterKey, letters) {

  Airwaves.currentArtistCluster = clusterKey;

  // Update active cluster button
  document.querySelectorAll('.c-artist-cluster').forEach(function(btn) {
    btn.classList.toggle('active', btn.dataset.cluster === clusterKey);
  });

  // Serve from cache if already fetched
  if (Airwaves.artistClusterCache[clusterKey]) {
    var cached = Airwaves.artistClusterCache[clusterKey];
    var artistCards = cached.map(function(artist) {
      return componentTemplate("artistItem", "", artist);
    });
    document.getElementById('newArtistsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + artistCards.join("") + "</ul>";
    return;
  }

  document.getElementById('newArtistsResults').innerHTML = "";
  document.getElementById('newArtistsResults').classList.add("is-loading");

  var formula = "OR(" + letters.map(function(l) {
    // digits don't need UPPER; letters do to catch lowercase names
    return isNaN(l)
      ? "LEFT(UPPER({Display Name}), 1) = '" + l + "'"
      : "LEFT({Display Name}, 1) = '" + l + "'";
  }).join(",") + ")";

  var clusterArtists = [];

  base('Artists')
    .select({
      sort: [{ field: 'Display Name', direction: 'asc' }],
      filterByFormula: formula,
      fields: artistsFieldsQuery
    })
    .eachPage(function page(records, fetchNextPage) {

      records.forEach(function(record) {

        var artist = [];
        artist["Display Name"] = "";
        artist["Record ID"] = "";
        artist["Image URL"] = "";
        artist["All Track IDs"] = "";
        artist["Track IDs (Main Artist)"] = "";
        artist["# Total Tracks"] = 0;
        artist["# Albums"] = 0;
        artist["Track Albums"] = "";
        artist["Track Albums Record IDs"] = "";

        if (artistsColumns["displayName"] in record.fields) {
          artist["Display Name"] = record.get(artistsColumns["displayName"]);
        }
        if (artistsColumns["recordID"] in record.fields) {
          artist["Record ID"] = record.get(artistsColumns["recordID"]);
        }
        if (artistsColumns["imageURL"] in record.fields) {
          artist["Image URL"] = record.get(artistsColumns["imageURL"]);
        }
        if (artistsColumns["allTrackIDs"] in record.fields) {
          artist["All Track IDs"] = record.get(artistsColumns["allTrackIDs"]);
        }
        if (artistsColumns["trackIDsMainArtist"] in record.fields) {
          artist["Track IDs (Main Artist)"] = record.get(artistsColumns["trackIDsMainArtist"]);
        }
        if (artistsColumns["totalTracks"] in record.fields) {
          artist["# Total Tracks"] = record.get(artistsColumns["totalTracks"]);
        }
        if (artistsColumns["totalAlbums"] in record.fields) {
          artist["# Albums"] = record.get(artistsColumns["totalAlbums"]);
        }
        if (artistsColumns["trackAlbums"] in record.fields) {
          artist["Track Albums"] = record.get(artistsColumns["trackAlbums"]);
        }
        if (artistsColumns["trackAlbumsRecordIDs"] in record.fields) {
          artist["Track Albums Record IDs"] = record.get(artistsColumns["trackAlbumsRecordIDs"]);
        }

        clusterArtists.push(artist);

        // Also keep global artistCache for openArtist lookups
        Airwaves.artistCache.push(artist);
      });

      fetchNextPage();

    }, function done(err) {

      document.getElementById('newArtistsResults').classList.remove("is-loading");

      if (err) { console.error(err); return; }

      Airwaves.artistClusterCache[clusterKey] = clusterArtists;

      var artistCards = clusterArtists.map(function(artist) {
        return componentTemplate("artistItem", "", artist);
      });

      document.getElementById('newArtistsResults').innerHTML = "<ul class='results__list results__list--grid results__list--albums'>" + artistCards.join("") + "</ul>";

    });
};

Airwaves.listArtistsByCluster(artistClusters[0].key, artistClusters[0].letters);

Airwaves.openArtist = function openArtist(recordID) {

  var artist = Airwaves.artistCache.find(
    item => item["Record ID"] === recordID
  );

  if (!artist) {
    base('Artists').find(recordID, function(err, record) {
      if (err) { console.error(err); return; }

      var fetched = [];
      fetched["Display Name"] = "";
      fetched["Record ID"] = "";
      fetched["Image URL"] = "";
      fetched["All Track IDs"] = "";
      fetched["Track IDs (Main Artist)"] = "";
      fetched["# Total Tracks"] = 0;
      fetched["# Albums"] = 0;
      fetched["Track Albums"] = "";
      fetched["Track Albums Record IDs"] = "";

      if (record.fields[artistsColumns["displayName"]]) fetched["Display Name"] = record.fields[artistsColumns["displayName"]];
      if (record.fields[artistsColumns["recordID"]]) fetched["Record ID"] = record.fields[artistsColumns["recordID"]];
      if (record.fields[artistsColumns["imageURL"]]) fetched["Image URL"] = record.fields[artistsColumns["imageURL"]];
      if (record.fields[artistsColumns["allTrackIDs"]]) fetched["All Track IDs"] = record.fields[artistsColumns["allTrackIDs"]];
      if (record.fields[artistsColumns["trackIDsMainArtist"]]) fetched["Track IDs (Main Artist)"] = record.fields[artistsColumns["trackIDsMainArtist"]];
      if (record.fields[artistsColumns["totalTracks"]]) fetched["# Total Tracks"] = record.fields[artistsColumns["totalTracks"]];
      if (record.fields[artistsColumns["totalAlbums"]]) fetched["# Albums"] = record.fields[artistsColumns["totalAlbums"]];
      if (record.fields[artistsColumns["trackAlbums"]]) fetched["Track Albums"] = record.fields[artistsColumns["trackAlbums"]];
      if (record.fields[artistsColumns["trackAlbumsRecordIDs"]]) fetched["Track Albums Record IDs"] = record.fields[artistsColumns["trackAlbumsRecordIDs"]];

      Airwaves.artistCache.push(fetched);
      Airwaves.openArtist(fetched["Record ID"]);
    });
    return;
  }

  Airwaves.previousLibraryView = document.body.__x.$data.library;

  document.body.__x.$data.library = 'artist-detail';

  var headerHTML = "";
  headerHTML += "<div class='c-collection-header'>";
    headerHTML += "<div class='c-collection-header__artwork c-collection-header__artwork--artist' style='background-image: url(" + artist["Image URL"] + ");'></div>";
    headerHTML += "<div class='c-collection-header__info'>";
      headerHTML += "<p class='c-collection-header__type'>Artist</p>";
      headerHTML += "<h2 class='c-collection-header__name'>" + artist["Display Name"] + "</h2>";
      headerHTML += "<p class='c-collection-header__count'>" + artist["# Total Tracks"] + " tracks</p>";
      headerHTML += "<div class='c-collection-header__actions'>";
        headerHTML += "<button type='button' class='button--secondary' data-action='playTrack' data-recordID='" + artist["All Track IDs"] + "'>Play All</button>";
        headerHTML += "<button type='button' class='button--secondary' data-action='addToQueue' data-recordID='" + artist["All Track IDs"] + "'>Add All to Queue</button>";
        headerHTML += Airwaves.shareButtonHTML('artist', artist["Record ID"]);
      headerHTML += "</div>";
    headerHTML += "</div>";
  headerHTML += "</div>";

  var container = document.getElementById('artistDetailResults');
  container.innerHTML = headerHTML;
  container.classList.add("is-loading");

  // Find matching albums — check cache first, fetch missing ones from Airtable
  var albumRecordIDs = artist["Track Albums Record IDs"] ? artist["Track Albums Record IDs"].split(', ').map(function(id) { return id.trim(); }) : [];

  function renderAlbumsAndFetchTracks(matchingAlbums) {
    var albumsHTML = "";
    if (matchingAlbums.length > 0) {
      albumsHTML += "<div class='c-artist-detail__section'>";
      albumsHTML += "<h3 class='c-artist-detail__section-title'>Albums</h3>";
      albumsHTML += "<ul class='results__list results__list--grid results__list--albums'>";
      matchingAlbums.forEach(function(album) {
        albumsHTML += componentTemplate("albumItem", "", album);
      });
      albumsHTML += "</ul>";
      albumsHTML += "</div>";
    }

    fetchArtistTracks(albumsHTML);
  }

  function fetchMissingAlbums(cachedAlbums, missingIDs) {
    var ALBUM_BATCH = 40;
    var albumBatches = [];
    for (var i = 0; i < missingIDs.length; i += ALBUM_BATCH) {
      albumBatches.push(missingIDs.slice(i, i + ALBUM_BATCH));
    }

    var fetchedAlbums = [];
    var albumBatchIndex = 0;

    function processAlbumBatch() {
      if (albumBatchIndex >= albumBatches.length) {
        // Add fetched albums to the collection cache
        fetchedAlbums.forEach(function(album) {
          Airwaves.collectionCache.push(album);
        });
        renderAlbumsAndFetchTracks(cachedAlbums.concat(fetchedAlbums));
        return;
      }

      var batch = albumBatches[albumBatchIndex];
      var formula = "OR(" + batch.map(function(id) { return "RECORD_ID() = '" + id + "'"; }).join(",") + ")";

      base('Albums')
        .select({
          filterByFormula: formula,
          fields: albumsFieldsQuery
        })
        .eachPage(function page(records, fetchNextPage) {
          records.forEach(function(record) {
            var album = [];
            album["Name"] = "";
            album["Record ID"] = "";
            album["Track Artists"] = "";
            album["Track IDs"] = "";
            album["Track Types"] = "";
            album["# Tracks"] = "";
            album["Album Artwork"] = "";

            if (albumsColumns["name"] in record.fields) {
              album["Name"] = record.get(albumsColumns["name"]);
            }
            if (albumsColumns["recordID"] in record.fields) {
              album["Record ID"] = record.get(albumsColumns["recordID"]);
            }
            if (albumsColumns["trackArtists"] in record.fields) {
              album["Track Artists"] = [...new Set(record.get(albumsColumns["trackArtists"]).split(', '))].join(', ');
            }
            if (albumsColumns["trackIDs"] in record.fields) {
              album["Track IDs"] = record.get(albumsColumns["trackIDs"]);
            }
            if (albumsColumns["trackTypes"] in record.fields) {
              album["Track Types"] = record.get(albumsColumns["trackTypes"]);
            }
            if (albumsColumns["trackCount"] in record.fields) {
              album["# Tracks"] = record.get(albumsColumns["trackCount"]);
            }
            if (albumsColumns["tracksAlbumArtworks"] in record.fields) {
              var firstArtwork = record.get(albumsColumns["tracksAlbumArtworks"])[0];
              if ("thumbnails" in firstArtwork) {
                if ("large" in firstArtwork.thumbnails) {
                  album["Album Artwork"] = firstArtwork.thumbnails.large.url;
                } else if ("small" in firstArtwork.thumbnails) {
                  album["Album Artwork"] = firstArtwork.thumbnails.small.url;
                }
              } else {
                album["Album Artwork"] = firstArtwork.url;
              }
            }

            album["Type"] = "album";
            fetchedAlbums.push(album);
          });
          fetchNextPage();
        }, function done(err) {
          if (err) { console.error(err); }
          albumBatchIndex++;
          processAlbumBatch();
        });
    }

    processAlbumBatch();
  }

  if (albumRecordIDs.length > 0) {
    var cachedIDSet = new Set();
    var cachedAlbums = [];
    Airwaves.collectionCache.forEach(function(c) {
      if (c["Type"] === "album" && albumRecordIDs.indexOf(c["Record ID"]) !== -1) {
        cachedAlbums.push(c);
        cachedIDSet.add(c["Record ID"]);
      }
    });
    var missingIDs = albumRecordIDs.filter(function(id) { return !cachedIDSet.has(id); });

    if (missingIDs.length > 0) {
      fetchMissingAlbums(cachedAlbums, missingIDs);
    } else {
      renderAlbumsAndFetchTracks(cachedAlbums);
    }
  } else {
    renderAlbumsAndFetchTracks([]);
  }

  function fetchArtistTracks(albumsHTML) {

  // Fetch all tracks in batches (Airtable URL length limit)
  var allIDs = artist["All Track IDs"];
  if (typeof allIDs === 'string') {
    allIDs = allIDs.split(',').map(function(id) { return id.trim(); });
  }

  var BATCH_SIZE = 40;
  var batches = [];
  for (var i = 0; i < allIDs.length; i += BATCH_SIZE) {
    batches.push(allIDs.slice(i, i + BATCH_SIZE));
  }

  var artistTracks = [];
  var batchesCompleted = 0;

  function processBatch(batchIndex) {
    if (batchIndex >= batches.length) {
      container.classList.remove("is-loading");

      var tracksHTML = "<div class='c-artist-detail__section'>";
      tracksHTML += "<h3 class='c-artist-detail__section-title'>Tracks</h3>";
      tracksHTML += "<ul class='results__list results__list--grid'>" + artistTracks.join("") + "</ul>";
      tracksHTML += "</div>";

      container.innerHTML = headerHTML + albumsHTML + tracksHTML;
      return;
    }

    var batch = batches[batchIndex];
    var filterFormula = "OR(";
    for (var j = 0; j < batch.length; j++) {
      filterFormula += "FIND('" + batch[j] + "', {Record ID (Airtable)}),";
    }
    filterFormula = filterFormula.slice(0, -1) + ")";

    base('Tracks')
      .select({
        view: "🔍 Has Artist",
        filterByFormula: filterFormula,
        fields: tracksFieldsQuery
      })
      .eachPage(function page(records, fetchNextPage) {

        records.forEach(function (record) {

          var track = [];
          track["Title"] = "";
          track["Record ID"] = "";
          track["Play URL"] = "";
          track["Track Name"] = "";
          track["Track Type"] = "";
          track["Artists"] = "";
          track["Featured Artists"] = "";
          track["Remix Artists"] = "";
          track["Album"] = "";
          track["Album Artwork URL"] = "";

          if (tracksColumns["title"] in record.fields) {
            track["Title"] = record.get(tracksColumns["title"]);
          }
          if (tracksColumns["recordID"] in record.fields) {
            track["Record ID"] = record.get(tracksColumns["recordID"]);
          }
          if (tracksColumns["trackFile"] in record.fields) {
            track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
          } else {
            if (tracksColumns["googleDriveURL"] in record.fields)
              track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
          }
          if (tracksColumns["trackName"] in record.fields) {
            track["Track Name"] = record.get(tracksColumns["trackName"]);
          }
          if (tracksColumns["trackType"] in record.fields) {
            track["Track Type"] = record.get(tracksColumns["trackType"]);
          }
          if (tracksColumns["artists"] in record.fields) {
            track["Artists"] = record.get(tracksColumns["artists"]);
          }
          if (tracksColumns["featuredArtists"] in record.fields) {
            track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
          }
          if (tracksColumns["remixArtists"] in record.fields) {
            track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
          }
          if (tracksColumns["album"] in record.fields) {
            track["Album"] = record.get(tracksColumns["album"]);
          }
          if (tracksColumns["artistIDs"] in record.fields) {
            track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
          }
          if (tracksColumns["featuredArtistIDs"] in record.fields) {
            track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
          }
          if (tracksColumns["remixArtistIDs"] in record.fields) {
            track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
          }
          if (tracksColumns["artistNamesLookup"] in record.fields) {
            track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
          }
          if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
            track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
          }
          if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
            track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
          }
          if (tracksColumns["albumID"] in record.fields) {
            track["Album ID"] = record.get(tracksColumns["albumID"]);
          }
          if (tracksColumns["playlists"] in record.fields) {
            track["Playlists"] = record.get(tracksColumns["playlists"]);
          }
          if (tracksColumns["albumArtwork"] in record.fields) {
            if ("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
              if ("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
              } else if ("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
              }
            } else {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
            }
          }

          Airwaves.trackCache.push(track);

          var trackItemTemplate = componentTemplate("trackItem", "", track);
          artistTracks.push(trackItemTemplate);
        });

        fetchNextPage();

      }, function done(err) {

        if (err) { console.error(err); return; }

        processBatch(batchIndex + 1);

      });
  }

  processBatch(0);

  } // end fetchArtistTracks
}

function playNextTrackInQueueFuture() {

  Airwaves.play(Airwaves.queueFuture[0]["Record ID"], Airwaves.queueFuture.shift());

  renderQueueFuture();

}

function prepareAndPlayNextTrack() {

  if (Airwaves.queueFuture.length === 0) {

    // empty queueFuture?
    // 1. populate it
    // 2. play the first one

    populateQueueFuture(playNextTrackInQueueFuture);

  }

  else {

    playNextTrackInQueueFuture();

  }

  if (Airwaves.audio.paused === false) {

    document.querySelector('.playPause').classList.add('paused');

  } else {

    document.querySelector('.playPause').classList.remove('paused');

  }

}

Airwaves.addToQueue = function addToQueue(recordIDs) {
  
  Airwaves.sendAlert('Added to queue');

  let listToProcess = new Array();

  if (recordIDs.includes(',')) {
    // it's a list, push each one to the array
    recordIDs = recordIDs.split(',');
  }

  listToProcess.push(recordIDs);

  let filterFormula = "OR(";

  // console.log(listToProcess);

  for (let recordID of listToProcess.flat(1)) {

    // OR(FIND(record), {Record ID (Airtable)})
    filterFormula = filterFormula + "FIND('" + recordID + "', {Record ID (Airtable)}),";

  }

  filterFormula = filterFormula.slice(0, -1); // remove last comma
  filterFormula = filterFormula + ")" // close the OR()

  // console.log(filterFormula);

  base('Tracks')
  .select({
    view: "🔍 Has Artist & Album",
    filterByFormula: filterFormula,
    fields: tracksFieldsQuery
  })
  .firstPage(function (err, records) {

    if (err) { console.error(err); return; }

    if ( records.length > 0 ) {

      records.forEach(function (record) {

        var track = [];
        track["Title"] = "";
        track["Record ID"] = "";
        track["Play URL"] = "";
        track["Track Name"] = "";
        track["Track Type"] = "";
        track["Artists"] = "";
        track["Featured Artists"] = "";
        track["Remix Artists"] = "";
        track["Album"] = "";
        track["Album Artwork URL"] = "";

        if (tracksColumns["title"] in record.fields) {
          track["Title"] = record.get(tracksColumns["title"]);
        }

        if (tracksColumns["recordID"] in record.fields) {
          track["Record ID"] = record.get(tracksColumns["recordID"]);
        }
        
        // ["Play URL"]
        // Play URL = Track File [url] OR Google Drive URL
        if (tracksColumns["trackFile"] in record.fields) {
          // console.log("found trackfile in Airtable!");
          track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
        } else {
          if(tracksColumns["googleDriveURL"] in record.fields)
          // console.log("found google drive trackfile!");
          track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
        }

        if (tracksColumns["trackName"] in record.fields) {
          track["Track Name"] = record.get(tracksColumns["trackName"]);
        }

        if (tracksColumns["trackType"] in record.fields) {
          track["Track Type"] = record.get(tracksColumns["trackType"]);
        }

        if (tracksColumns["artists"] in record.fields) {
          track["Artists"] = record.get(tracksColumns["artists"]);
        }

        if (tracksColumns["featuredArtists"] in record.fields) {
          track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
        }

        if (tracksColumns["remixArtists"] in record.fields) {
          track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
        }

        if (tracksColumns["album"] in record.fields) {
          track["Album"] = record.get(tracksColumns["album"]);
        }
        if (tracksColumns["artistIDs"] in record.fields) {
          track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
        }
        if (tracksColumns["featuredArtistIDs"] in record.fields) {
          track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
        }
        if (tracksColumns["remixArtistIDs"] in record.fields) {
          track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
        }
        if (tracksColumns["artistNamesLookup"] in record.fields) {
          track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
        }
        if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
          track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
        }
        if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
          track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
        }
        if (tracksColumns["albumID"] in record.fields) {
          track["Album ID"] = record.get(tracksColumns["albumID"]);
        }
        if (tracksColumns["playlists"] in record.fields) {
          track["Playlists"] = record.get(tracksColumns["playlists"]);
        }

        if (tracksColumns["albumArtwork"] in record.fields) {

          if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {

            if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
            }

            else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
            }
          }
          else {
            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
          }
        }

        Airwaves.trackCache.push(track);

        Airwaves.queueFuture.unshift(track);

        // var trackItemTemplate = componentTemplate("trackItem", "", track);

        // searchResultTracks.push(trackItemTemplate);
      });

      renderQueueFuture();

    } else {

    }

  });

  renderQueueFuture();
}

// Deep-link entry point: open an album or playlist by record id even when it
// isn't in the browse cache yet (e.g. arriving via a shared URL). Fetches the
// record from the matching table, builds a collection object shaped like the
// ones listNewAlbums/listNewPlaylists cache, then hands off to openCollection.
Airwaves.openCollectionById = function openCollectionById(recordID, type) {

  var cached = Airwaves.collectionCache.find(item => item["Record ID"] === recordID);
  if (cached) {
    Airwaves.openCollection(recordID);
    return;
  }

  var isPlaylist = type === "playlist";
  var tableName = isPlaylist ? "Playlists" : "Albums";
  var cols = isPlaylist ? playlistsColumns : albumsColumns;

  base(tableName).find(recordID, function (err, record) {
    if (err) { console.error(err); return; }

    var collection = [];
    collection["Name"] = (cols["name"] in record.fields) ? record.get(cols["name"]) : "";
    collection["Record ID"] = (cols["recordID"] in record.fields) ? record.get(cols["recordID"]) : recordID;
    collection["Track Artists"] = (cols["trackArtists"] in record.fields)
      ? [...new Set(record.get(cols["trackArtists"]).split(', '))].join(', ') : "";
    collection["Track IDs"] = (cols["trackIDs"] in record.fields) ? record.get(cols["trackIDs"]) : "";
    collection["# Tracks"] = (cols["trackCount"] in record.fields) ? record.get(cols["trackCount"]) : "";
    collection["Album Artwork"] = "";

    if (cols["tracksAlbumArtworks"] in record.fields) {
      var firstArtwork = record.get(cols["tracksAlbumArtworks"])[0];
      if (firstArtwork) {
        if ("thumbnails" in firstArtwork && "large" in firstArtwork.thumbnails) {
          collection["Album Artwork"] = firstArtwork.thumbnails.large.url;
        } else if ("thumbnails" in firstArtwork && "small" in firstArtwork.thumbnails) {
          collection["Album Artwork"] = firstArtwork.thumbnails.small.url;
        } else {
          collection["Album Artwork"] = firstArtwork.url;
        }
      }
    }

    collection["Type"] = isPlaylist ? "playlist" : "album";
    Airwaves.collectionCache.push(collection);
    Airwaves.openCollection(collection["Record ID"]);
  });
};

Airwaves.openCollection = function openCollection(recordID) {

  var collection = Airwaves.collectionCache.find(
    item => item["Record ID"] === recordID
  );

  if (!collection) {
    console.error("Collection not found in cache: " + recordID);
    return;
  }

  Airwaves.previousLibraryView = document.body.__x.$data.library;

  document.body.__x.$data.library = 'collection';

  var headerHTML = "";
  headerHTML += "<div class='c-collection-header'>";
    headerHTML += "<div class='c-collection-header__artwork thumbnail--album' style='background-image: url(" + collection["Album Artwork"] + ");'></div>";
    headerHTML += "<div class='c-collection-header__info'>";
      headerHTML += "<p class='c-collection-header__type'>" + (collection["Type"] === "album" ? "Album" : "Playlist") + "</p>";
      headerHTML += "<h2 class='c-collection-header__name'>" + collection["Name"] + "</h2>";
      headerHTML += "<p class='c-collection-header__artists'>" + collection["Track Artists"] + "</p>";
      headerHTML += "<p class='c-collection-header__count'>" + collection["# Tracks"] + " tracks</p>";
      headerHTML += "<div class='c-collection-header__actions'>";
        headerHTML += "<button type='button' class='button--secondary' data-action='playTrack' data-recordID='" + collection["Track IDs"] + "'>Play All</button>";
        headerHTML += "<button type='button' class='button--secondary' data-action='addToQueue' data-recordID='" + collection["Track IDs"] + "'>Add All to Queue</button>";
        headerHTML += Airwaves.shareButtonHTML(collection["Type"] === "playlist" ? "playlist" : "album", collection["Record ID"]);
      headerHTML += "</div>";
    headerHTML += "</div>";
  headerHTML += "</div>";

  var container = document.getElementById('collectionResults');
  container.innerHTML = headerHTML;
  container.classList.add("is-loading");

  var trackIDs = collection["Track IDs"];
  let listToProcess = new Array();

  if (trackIDs.includes(',')) {
    trackIDs = trackIDs.split(',');
  }

  listToProcess.push(trackIDs);

  let filterFormula = "OR(";

  for (let id of listToProcess.flat(1)) {
    filterFormula += "FIND('" + id + "', {Record ID (Airtable)}),";
  }

  filterFormula = filterFormula.slice(0, -1);
  filterFormula += ")";

  var collectionTracks = [];

  base('Tracks')
    .select({
      view: "🔍 Has Artist & Album",
      filterByFormula: filterFormula,
      fields: tracksFieldsQuery
    })
    .eachPage(function page(records, fetchNextPage) {

      records.forEach(function (record) {

        var track = [];
        track["Title"] = "";
        track["Record ID"] = "";
        track["Play URL"] = "";
        track["Track Name"] = "";
        track["Track Type"] = "";
        track["Artists"] = "";
        track["Featured Artists"] = "";
        track["Remix Artists"] = "";
        track["Album"] = "";
        track["Album Artwork URL"] = "";

        if (tracksColumns["title"] in record.fields) {
          track["Title"] = record.get(tracksColumns["title"]);
        }
        if (tracksColumns["recordID"] in record.fields) {
          track["Record ID"] = record.get(tracksColumns["recordID"]);
        }
        if (tracksColumns["trackFile"] in record.fields) {
          track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
        } else {
          if (tracksColumns["googleDriveURL"] in record.fields)
            track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
        }
        if (tracksColumns["trackName"] in record.fields) {
          track["Track Name"] = record.get(tracksColumns["trackName"]);
        }
        if (tracksColumns["trackType"] in record.fields) {
          track["Track Type"] = record.get(tracksColumns["trackType"]);
        }
        if (tracksColumns["artists"] in record.fields) {
          track["Artists"] = record.get(tracksColumns["artists"]);
        }
        if (tracksColumns["featuredArtists"] in record.fields) {
          track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
        }
        if (tracksColumns["remixArtists"] in record.fields) {
          track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
        }
        if (tracksColumns["album"] in record.fields) {
          track["Album"] = record.get(tracksColumns["album"]);
        }
        if (tracksColumns["artistIDs"] in record.fields) {
          track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
        }
        if (tracksColumns["featuredArtistIDs"] in record.fields) {
          track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
        }
        if (tracksColumns["remixArtistIDs"] in record.fields) {
          track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
        }
        if (tracksColumns["artistNamesLookup"] in record.fields) {
          track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
        }
        if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
          track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
        }
        if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
          track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
        }
        if (tracksColumns["albumID"] in record.fields) {
          track["Album ID"] = record.get(tracksColumns["albumID"]);
        }
        if (tracksColumns["playlists"] in record.fields) {
          track["Playlists"] = record.get(tracksColumns["playlists"]);
        }
        if (tracksColumns["albumArtwork"] in record.fields) {
          if ("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
            if ("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
            } else if ("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
            }
          } else {
            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
          }
        }

        Airwaves.trackCache.push(track);

        var trackItemTemplate = componentTemplate("trackItem", "", track);
        collectionTracks.push(trackItemTemplate);
      });

      fetchNextPage();

    }, function done(err) {

      container.classList.remove("is-loading");

      if (err) { console.error(err); return; }

      container.innerHTML = headerHTML + "<ul class='results__list results__list--grid'>" + collectionTracks.join("") + "</ul>";

    });
}

Airwaves.playPause = function playPause() {

  if (Airwaves.audio.paused === false) {

    pauseAudio();
    
  } else {

    playAudio();
    
  }
}

function playAudio() {
  // play() returns a promise that rejects if the load is interrupted (e.g. a
  // new track is selected before this one is ready) or if autoplay is blocked.
  // Swallow that rejection so it doesn't surface as an uncaught error.
  var playPromise = Airwaves.audio.play();
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(function () { /* interrupted or autoplay-blocked; ignore */ });
  }
  document.body.classList.add('is-playing');
  document.querySelector('.playPause').classList.remove('paused');
  navigator.mediaSession.playbackState = "playing";
}

function pauseAudio() {
  Airwaves.audio.pause();

    document.body.classList.remove('is-playing');
    document.querySelector('.playPause').classList.add('paused');
    navigator.mediaSession.playbackState = "paused";
}


/* ------------------------------------------------------------------ *
 * Waveform scrubber
 *
 * Fetches the current track (same-origin /stream proxy), decodes it with
 * the Web Audio API, and reduces it to a fixed set of amplitude peaks that
 * are drawn as bars on a canvas. The bars double as a seek bar: click or
 * drag anywhere to scrobble.
 *
 * Peaks are sourced in priority order, cheapest first:
 *   1. in-memory cache (per session)
 *   2. the Airtable "Waveform Peaks" field, read on demand for just the track
 *      being played (a few hundred bytes)
 *   3. decode the audio in the browser as a fallback, then write the result
 *      back to Airtable so nobody has to decode it again.
 * ------------------------------------------------------------------ */
Airwaves.waveform = (function () {

  // Stored resolution. Kept deliberately low (was 400) — a chunky sidebar
  // waveform needs far fewer points, and it keeps the stored string tiny.
  var SAMPLES = 96;      // amplitudes stored/computed per track
  var WAVEFORM_FIELD = 'Waveform Peaks';   // Airtable long-text field
  var BAR_WIDTH = 3;     // px (CSS) per drawn bar
  var BAR_GAP = 1;       // px (CSS) between bars

  var el = document.getElementById('waveform');
  var canvas = document.getElementById('waveformCanvas');
  var currentLabel = document.getElementById('waveformCurrent');
  var durationLabel = document.getElementById('waveformDuration');
  var ctx = canvas ? canvas.getContext('2d') : null;

  var cache = {};        // recordID -> Float array of peaks (0..1)
  var peaks = null;      // peaks for the current track
  var token = 0;         // bumps on every load, so stale fetches are ignored
  var audioCtx = null;
  var scrubbing = false;

  function color(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }

  function formatTime(seconds) {
    if (!isFinite(seconds) || seconds < 0) seconds = 0;
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function progress() {
    var d = Airwaves.audio.duration;
    if (!isFinite(d) || d <= 0) return 0;
    return Math.min(1, Math.max(0, Airwaves.audio.currentTime / d));
  }

  function draw() {
    if (!ctx || !canvas) return;

    var cssWidth = canvas.clientWidth;
    var cssHeight = canvas.clientHeight;
    if (cssWidth === 0 || cssHeight === 0) return; // collapsed / not visible yet

    var dpr = window.devicePixelRatio || 1;
    if (canvas.width !== Math.round(cssWidth * dpr) ||
        canvas.height !== Math.round(cssHeight * dpr)) {
      canvas.width = Math.round(cssWidth * dpr);
      canvas.height = Math.round(cssHeight * dpr);
    }

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cssWidth, cssHeight);

    var barCount = Math.max(1, Math.floor(cssWidth / (BAR_WIDTH + BAR_GAP)));
    var played = progress();
    var mid = cssHeight / 2;
    var playedColor = color('--color-cryan-500') || '#00c2e0';
    var restColor = color('--color-maeve-650') || '#554e7b';

    for (var i = 0; i < barCount; i++) {
      var amp = peaks ? peaks[Math.floor(i / barCount * peaks.length)] : 0.15;
      var barH = Math.max(2, amp * cssHeight);
      var x = i * (BAR_WIDTH + BAR_GAP);
      ctx.fillStyle = (i / barCount) <= played ? playedColor : restColor;
      ctx.fillRect(x, mid - barH / 2, BAR_WIDTH, barH);
    }
  }

  // Reduce raw channel data down to SAMPLES normalized peaks (0..1).
  function computePeaks(audioBuffer) {
    var raw = audioBuffer.getChannelData(0);
    var block = Math.floor(raw.length / SAMPLES) || 1;
    var out = new Float32Array(SAMPLES);
    var max = 0;
    for (var i = 0; i < SAMPLES; i++) {
      var start = i * block;
      var peak = 0;
      for (var j = 0; j < block; j++) {
        var v = Math.abs(raw[start + j] || 0);
        if (v > peak) peak = v;
      }
      out[i] = peak;
      if (peak > max) max = peak;
    }
    // Normalize so the loudest peak fills the height.
    if (max > 0) {
      for (var k = 0; k < SAMPLES; k++) out[k] = out[k] / max;
    }
    return out;
  }

  // Storage format: comma-separated integers 0..255, e.g. "128,90,...".
  // Deliberately plain text so it's trivial to produce and parse anywhere the
  // waveform gets written — the browser, a Netlify function, or an Airtable
  // automation script — without depending on base64/atob.
  function peaksToString(floatPeaks) {
    var parts = [];
    for (var i = 0; i < floatPeaks.length; i++) {
      parts.push(Math.round(Math.min(1, Math.max(0, floatPeaks[i])) * 255));
    }
    return parts.join(',');
  }

  function parsePeaks(str) {
    if (!str || typeof str !== 'string') return null;
    var parts = str.split(',');
    if (parts.length < 8) return null;              // too short to be real
    var out = new Float32Array(parts.length);
    for (var i = 0; i < parts.length; i++) {
      var n = parseInt(parts[i], 10);
      if (!isFinite(n) || n < 0 || n > 255) return null;
      out[i] = n / 255;
    }
    return out;
  }

  function show(newPeaks, id) {
    peaks = newPeaks;
    if (id && newPeaks) cache[id] = newPeaks;
    el.classList.remove('is-loading');
    draw();
  }

  function load(track) {
    if (!el || !ctx) return;

    var id = track && track["Record ID"];
    var myToken = ++token;

    // Reset UI for the new track.
    peaks = null;
    el.classList.add('is-loading');
    if (currentLabel) currentLabel.textContent = '0:00';
    if (durationLabel) durationLabel.textContent = '0:00';
    draw();

    // 1. Session cache.
    if (id && cache[id]) { show(cache[id], id); return; }

    // 2. Peaks already on the track object (if a caller threaded the field).
    var inline = track && parsePeaks(track[WAVEFORM_FIELD]);
    if (inline) { show(inline, id); return; }

    var src = track && (track["Record ID"]
      ? (window.location.origin + '/stream?track=' + encodeURIComponent(track["Record ID"]))
      : track["Play URL"]);

    // 3. Read the stored field for just this track (a few hundred bytes), then
    //    fall back to decoding the audio only if it isn't stored yet.
    fetchStoredPeaks(id)
      .then(function (stored) {
        if (myToken !== token) return;
        if (stored) { show(stored, id); return; }
        scheduleDecode(id, src, myToken);   // not stored → decode + write back
      })
      .catch(function () {
        if (myToken !== token) return;
        scheduleDecode(id, src, myToken);
      });
  }

  // On-demand read of the Waveform Peaks field for one record via the (read
  // only) Airtable proxy. Resolves to a Float32Array, or null if not stored.
  // Rejects if the lookup itself failed (e.g. the field doesn't exist yet).
  function fetchStoredPeaks(id) {
    if (!id || typeof base !== 'function') return Promise.resolve(null);
    return new Promise(function (resolve, reject) {
      base('Tracks').select({
        maxRecords: 1,
        fields: [WAVEFORM_FIELD],
        filterByFormula: "RECORD_ID() = '" + id + "'"
      }).firstPage(function (err, records) {
        if (err) return reject(err);
        var rec = records && records[0];
        resolve(rec ? parsePeaks(rec.get(WAVEFORM_FIELD)) : null);
      });
    });
  }

  // Persist freshly-decoded peaks so no one has to decode this track again.
  // Called at the function's direct path — Netlify wasn't applying a pretty
  // /waveform redirect from netlify.toml (though /airtable's splat works).
  function writeBackPeaks(id, str) {
    if (!id || !str) return;
    fetch(window.location.origin + '/.netlify/functions/waveform', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ track: id, peaks: str })
    }).catch(function () { /* best effort; a failed write just means we decode again next time */ });
  }

  // The waveform needs the whole file, so decoding fetches the same /stream URL
  // a second time. Downloading it immediately competes with the <audio> element
  // for bandwidth and doubles the request rate to the upstream (Google Drive),
  // which starves playback and can trip rate limits. So we hold off until the
  // audio is comfortably playing, then fetch at low priority. A fallback timer
  // covers the case where 'playing' never fires.
  function scheduleDecode(id, src, myToken) {
    if (!src) { el.classList.remove('is-loading'); draw(); return; }
    var started = false;
    var fallback;
    function begin() {
      Airwaves.audio.removeEventListener('playing', begin);
      clearTimeout(fallback);
      if (started || myToken !== token) return; // superseded by a newer track
      started = true;
      decodeAndStore(id, src, myToken);
    }
    Airwaves.audio.addEventListener('playing', begin);
    fallback = setTimeout(begin, 5000);
  }

  function decodeAndStore(id, src, myToken) {
    try {
      audioCtx = audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) {
      return; // Web Audio unavailable; leave the placeholder bars.
    }

    // `priority: 'low'` yields bandwidth to the audio stream (ignored by
    // browsers that don't support it).
    fetch(src, { priority: 'low' })
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) {
        if (myToken !== token) throw 'stale';
        return audioCtx.decodeAudioData(buf);
      })
      .then(function (audioBuffer) {
        if (myToken !== token) return; // a newer track started; drop this result
        var computed = computePeaks(audioBuffer);
        show(computed, id);
        writeBackPeaks(id, peaksToString(computed));
      })
      .catch(function (err) {
        if (err === 'stale' || myToken !== token) return;
        // Decode failed (unsupported codec, network, etc.) — show flat bars.
        peaks = null;
        el.classList.remove('is-loading');
        draw();
      });
  }

  function seekToClientX(clientX) {
    var d = Airwaves.audio.duration;
    if (!isFinite(d) || d <= 0) return;
    var rect = canvas.getBoundingClientRect();
    var ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    Airwaves.audio.currentTime = ratio * d;
    draw();
  }

  // --- pointer scrobbing -------------------------------------------
  if (el && canvas) {
    canvas.addEventListener('pointerdown', function (e) {
      scrubbing = true;
      canvas.setPointerCapture(e.pointerId);
      seekToClientX(e.clientX);
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) {
      if (scrubbing) seekToClientX(e.clientX);
    });
    function endScrub(e) {
      if (scrubbing) {
        scrubbing = false;
        try { canvas.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }
    canvas.addEventListener('pointerup', endScrub);
    canvas.addEventListener('pointercancel', endScrub);

    // Keyboard seeking when the waveform is focused.
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        Airwaves.audio.currentTime = Math.min(Airwaves.audio.duration || 0, Airwaves.audio.currentTime + 5);
        e.preventDefault();
      } else if (e.key === 'ArrowLeft') {
        Airwaves.audio.currentTime = Math.max(0, Airwaves.audio.currentTime - 5);
        e.preventDefault();
      }
    });

    // Keep bars sized correctly as the player expands / the window resizes.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { draw(); }).observe(canvas);
    } else {
      window.addEventListener('resize', draw);
    }
  }

  // --- keep the playhead + labels in sync --------------------------
  Airwaves.audio.addEventListener('timeupdate', function () {
    if (currentLabel) currentLabel.textContent = formatTime(Airwaves.audio.currentTime);
    if (el) el.setAttribute('aria-valuenow', Math.round(progress() * 100));
    draw();
  });
  Airwaves.audio.addEventListener('loadedmetadata', function () {
    if (durationLabel) durationLabel.textContent = formatTime(Airwaves.audio.duration);
    draw();
  });

  return { load: load, draw: draw };
})();


Airwaves.ended = function ended() {

  // console.log('Audio ended');

  prepareAndPlayNextTrack();

}


Airwaves.skipTrack = function skipTrack() {

  // console.log('Track skipped');
  Airwaves.sendAlert('Track skipped');

  prepareAndPlayNextTrack();

}

Airwaves.previousTrack = function previousTrack() {

  if (Airwaves.queuePast.length === 0) {
    // Nothing behind us — restart the current track instead.
    Airwaves.sendAlert('No previous track');
    Airwaves.audio.currentTime = 0;
    return;
  }

  // Pop the most recently played track and play it. The _navBack flag makes
  // reloadAudio send the current track to the front of the future queue
  // (rather than onto history), so previous/next stay symmetric.
  var prev = Airwaves.queuePast.pop();
  renderQueuePast();
  Airwaves._navBack = true;
  Airwaves.play(prev["Record ID"]);

}

Airwaves.seekForward = function seekForward() {

  // console.log('Seeked forward');

  Airwaves.audio.currentTime += 15.0;

}

Airwaves.seekBackward = function seekBackward() {

  // console.log('Seeked backward');

  Airwaves.audio.currentTime -= 15.0;

}

function renderQueuePast() {

  // clear queuepast
  document.getElementById('queuePast').innerHTML = "";

  // loop through new queuepast and render items
  Airwaves.queuePast.forEach((track) => {

    var trackItemTemplate = componentTemplate("trackItem", "", track);

    document.getElementById('queuePast').insertAdjacentHTML('beforeend', trackItemTemplate);
    
  });

}

function renderQueueCurrent() {

  var track = Airwaves.queueCurrent;

  var trackItemTemplate = componentTemplate("trackItem", "noControls", track);

  // clear, then update
  document.getElementById('queueCurrent').innerHTML = "";
  document.getElementById('queueCurrent').insertAdjacentHTML('beforeend', trackItemTemplate);

}

function renderQueueFuture() {

  // console.log('Start "renderQueueFuture"');

  // clear queueFuture
  document.getElementById('queueFuture').innerHTML = "";

  // loop through new queueFuture and render items
  Airwaves.queueFuture.forEach((track, index) => {

    var trackItemTemplate = componentTemplate("trackItem", "queue", track);

    document.getElementById('queueFuture').insertAdjacentHTML('beforeend', trackItemTemplate);
  });

  // Re-attach drag listeners after re-render
  initQueueDragAndDrop();

}

function initQueueDragAndDrop() {

  var list = document.getElementById('queueFuture');
  if (!list) return;

  var dragItem = null;
  var dropIndicator = null;
  var dragOffsetY = 0;
  var dropTarget = null; // { ref: element, position: 'before'|'after' }

  list.querySelectorAll('.c-track-result__drag-handle').forEach(function(handle) {

    handle.addEventListener('pointerdown', function(e) {
      e.preventDefault();
      var li = handle.closest('li');
      if (!li) return;

      dragItem = li;

      var rect = li.getBoundingClientRect();
      dragOffsetY = e.clientY - rect.top;

      // Create the drop indicator line
      dropIndicator = document.createElement('li');
      dropIndicator.className = 'c-queue-drop-indicator';

      // Style the dragged item as floating
      dragItem.classList.add('is-dragging');
      dragItem.style.width = rect.width + 'px';
      dragItem.style.top = rect.top + 'px';
      dragItem.style.left = rect.left + 'px';

      handle.setPointerCapture(e.pointerId);
    });

    handle.addEventListener('pointermove', function(e) {
      if (!dragItem) return;

      var newTop = e.clientY - dragOffsetY;
      dragItem.style.top = newTop + 'px';

      // Remove existing indicator
      if (dropIndicator.parentNode) {
        dropIndicator.remove();
      }

      // Find the gap we're closest to
      var siblings = Array.from(list.querySelectorAll('li:not(.is-dragging):not(.c-queue-drop-indicator)'));
      var inserted = false;

      for (var i = 0; i < siblings.length; i++) {
        var sibRect = siblings[i].getBoundingClientRect();
        var sibMid = sibRect.top + sibRect.height / 2;

        if (e.clientY < sibMid) {
          list.insertBefore(dropIndicator, siblings[i]);
          dropTarget = { ref: siblings[i], position: 'before' };
          inserted = true;
          break;
        }
      }

      if (!inserted && siblings.length > 0) {
        // Past the last item — show indicator after the last one
        var lastSib = siblings[siblings.length - 1];
        lastSib.after(dropIndicator);
        dropTarget = { ref: lastSib, position: 'after' };
      }
    });

    handle.addEventListener('pointerup', function(e) {
      if (!dragItem) return;

      // Move the dragged item to the indicator position
      if (dropTarget && dropIndicator.parentNode) {
        if (dropTarget.position === 'before') {
          list.insertBefore(dragItem, dropTarget.ref);
        } else {
          dropTarget.ref.after(dragItem);
        }
      }

      // Clean up
      if (dropIndicator.parentNode) dropIndicator.remove();

      dragItem.classList.remove('is-dragging');
      dragItem.style.width = '';
      dragItem.style.top = '';
      dragItem.style.left = '';

      // Sync queueFuture array to new DOM order
      var newOrder = [];
      list.querySelectorAll('li:not(.c-queue-drop-indicator) .c-track-result').forEach(function(el) {
        var id = el.dataset.recordid;
        for (var i = 0; i < Airwaves.queueFuture.length; i++) {
          if (Airwaves.queueFuture[i]["Record ID"] === id) {
            newOrder.push(Airwaves.queueFuture[i]);
            Airwaves.queueFuture.splice(i, 1);
            break;
          }
        }
      });
      Airwaves.queueFuture = newOrder;

      dragItem = null;
      dropTarget = null;
    });

    handle.addEventListener('pointercancel', function(e) {
      if (!dragItem) return;
      if (dropIndicator && dropIndicator.parentNode) dropIndicator.remove();
      dragItem.classList.remove('is-dragging');
      dragItem.style.width = '';
      dragItem.style.top = '';
      dragItem.style.left = '';
      dragItem = null;
      dropTarget = null;
    });
  });
}

function populateQueueFuture(callback) {

  // how many tracks do we need?

  var maxQueueFutureLength = 25;

  var queueFutureCount = Airwaves.queueFuture.length;

  var requiredTracksCount = maxQueueFutureLength - queueFutureCount;

  // console.log("Queue Future Count: " + queueFutureCount);
  // console.log("More Future Tracks Required: " + requiredTracksCount);

  if (requiredTracksCount > 0) {

    // make array of all records not allowed

    var disabledRecordIDs = [];
    Airwaves.queuePast.map(item => { disabledRecordIDs.push(item["Record ID"]) });
    Airwaves.queueFuture.map(item => { disabledRecordIDs.push(item["Record ID"]) });
    disabledRecordIDs.push(Airwaves.queueCurrent["Record ID"]);

    base('Tracks')
      .select({
        maxRecords: requiredTracksCount,
        view: "🔍 Has Artist & Album",
        filterByFormula: "AND(LOWER({" + tracksColumns["album"].replace(/'/g, "\\\'")  + "}) = LOWER('" + Airwaves.queueCurrent["Album"].replace(/'/g, "\\\'") + "'), FIND({" + tracksColumns["recordID"].replace(/'/g, "\\\'")  + "}, '" + disabledRecordIDs.join() + "') = 0)",
        fields: tracksFieldsQuery
      })
      .firstPage(function (err, records) {

        if (err) { console.error(err); return; }

        records.forEach(function (record) {

          // console.log('Matching track from album', record.get('Title'));

          // 1 less needed
          requiredTracksCount--;

          var track = [];
          track["Title"] = "";
          track["Record ID"] = "";
          track["Play URL"] = "";
          track["Track Name"] = "";
          track["Track Type"] = "";
          track["Artists"] = "";
          track["Featured Artists"] = "";
          track["Remix Artists"] = "";
          track["Album"] = "";
          track["Album Artwork URL"] = "";

          if (tracksColumns["title"] in record.fields) {
            track["Title"] = record.get(tracksColumns["title"]);
          }

          if (tracksColumns["recordID"] in record.fields) {
            track["Record ID"] = record.get(tracksColumns["recordID"]);
          }
          
          // ["Play URL"]
          // Play URL = Track File [url] OR Google Drive URL
          if (tracksColumns["trackFile"] in record.fields) {
            // console.log("found trackfile in Airtable!");
            track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
          } else {
            if(tracksColumns["googleDriveURL"] in record.fields)
            // console.log("found google drive trackfile!");
            track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
          }

          if (tracksColumns["trackName"] in record.fields) {
            track["Track Name"] = record.get(tracksColumns["trackName"]);
          }

          if (tracksColumns["trackType"] in record.fields) {
            track["Track Type"] = record.get(tracksColumns["trackType"]);
          }

          if (tracksColumns["artists"] in record.fields) {
            track["Artists"] = record.get(tracksColumns["artists"]);
          }

          if (tracksColumns["featuredArtists"] in record.fields) {
            track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
          }

          if (tracksColumns["remixArtists"] in record.fields) {
            track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
          }

          if (tracksColumns["album"] in record.fields) {
            track["Album"] = record.get(tracksColumns["album"]);
          }
          if (tracksColumns["artistIDs"] in record.fields) {
            track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
          }
          if (tracksColumns["featuredArtistIDs"] in record.fields) {
            track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
          }
          if (tracksColumns["remixArtistIDs"] in record.fields) {
            track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
          }
          if (tracksColumns["artistNamesLookup"] in record.fields) {
            track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
          }
          if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
            track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
          }
          if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
            track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
          }
          if (tracksColumns["albumID"] in record.fields) {
            track["Album ID"] = record.get(tracksColumns["albumID"]);
          }
          if (tracksColumns["playlists"] in record.fields) {
            track["Playlists"] = record.get(tracksColumns["playlists"]);
          }

          if (tracksColumns["albumArtwork"] in record.fields) {
            // console.log("found album artwork url!");

            if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
              // console.log("has thumbnails!");

              if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                // console.log("has large thumbnail!");
                track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
              }

              else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                // console.log("has small thumbnail!");
                track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
              }
            }
            else {
              // console.log("no thumbnails, just fullsize!");
              track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
            }
          }

          Airwaves.trackCache.push(track);
          Airwaves.queueFuture.push(track);

          // console.log("Airwaves.queueFuture:");
          // console.table(Airwaves.queueFuture);

          // console.log("New Queue Future Count after Album Match: " + Airwaves.queueFuture.length);

          renderQueueFuture();

        });

        // console.log('After find album matches, we still need ' + requiredTracksCount);

        if (requiredTracksCount > 0) {

          // add any new IDs to the disabledRecordIDs array;
          Airwaves.queueFuture.map(item => { disabledRecordIDs.push(item["Record ID"]) });

          base('Tracks')
            .select({
              maxRecords: requiredTracksCount,
              view: "🔍 Has Artist",
              filterByFormula: "AND(FIND(LOWER('" + Airwaves.queueCurrent["Artists"].replace(/'/g, "\\\'") + "'), LOWER(" + tracksColumns["artists"].replace(/'/g, "\\\'")  + ")), FIND({" + tracksColumns["recordID"].replace(/'/g, "\\\'")  + "}, '" + disabledRecordIDs.join() + "') = 0)",
              fields: tracksFieldsQuery
            })
            .firstPage(function (err, records) {

              if (err) { console.error(err); return; }

              records.forEach(function (record) {

                // 1 less needed
                requiredTracksCount--;

                var track = [];
                track["Title"] = "";
                track["Record ID"] = "";
                track["Play URL"] = "";
                track["Track Name"] = "";
                track["Track Type"] = "";
                track["Artists"] = "";
                track["Featured Artists"] = "";
                track["Remix Artists"] = "";
                track["Album"] = "";
                track["Album Artwork URL"] = "";

                if (tracksColumns["title"] in record.fields) {
                  track["Title"] = record.get(tracksColumns["title"]);
                }

                if (tracksColumns["recordID"] in record.fields) {
                  track["Record ID"] = record.get(tracksColumns["recordID"]);
                }
                
                // ["Play URL"]
                // Play URL = Track File [url] OR Google Drive URL
                if (tracksColumns["trackFile"] in record.fields) {
                  // console.log("found trackfile in Airtable!");
                  track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
                } else {
                  if(tracksColumns["googleDriveURL"] in record.fields)
                  // console.log("found google drive trackfile!");
                  track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
                }

                if (tracksColumns["trackName"] in record.fields) {
                  track["Track Name"] = record.get(tracksColumns["trackName"]);
                }

                if (tracksColumns["trackType"] in record.fields) {
                  track["Track Type"] = record.get(tracksColumns["trackType"]);
                }

                if (tracksColumns["artists"] in record.fields) {
                  track["Artists"] = record.get(tracksColumns["artists"]);
                }

                if (tracksColumns["featuredArtists"] in record.fields) {
                  track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
                }

                if (tracksColumns["remixArtists"] in record.fields) {
                  track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
                }

                if (tracksColumns["album"] in record.fields) {
                  track["Album"] = record.get(tracksColumns["album"]);
                }
                if (tracksColumns["artistIDs"] in record.fields) {
                  track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
                }
                if (tracksColumns["featuredArtistIDs"] in record.fields) {
                  track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
                }
                if (tracksColumns["remixArtistIDs"] in record.fields) {
                  track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
                }
                if (tracksColumns["artistNamesLookup"] in record.fields) {
                  track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
                }
                if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
                  track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
                }
                if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
                  track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
                }
                if (tracksColumns["albumID"] in record.fields) {
                  track["Album ID"] = record.get(tracksColumns["albumID"]);
                }
                if (tracksColumns["playlists"] in record.fields) {
                  track["Playlists"] = record.get(tracksColumns["playlists"]);
                }

                if (tracksColumns["albumArtwork"] in record.fields) {
                  // console.log("found album artwork url!");

                  if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
                    // console.log("has thumbnails!");

                    if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                      // console.log("has large thumbnail!");
                      track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
                    }

                    else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                      // console.log("has small thumbnail!");
                      track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
                    }
                  }
                  else {
                    // console.log("no thumbnails, just fullsize!");
                    track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
                  }
                }

                Airwaves.trackCache.push(track);
                Airwaves.queueFuture.push(track);

                renderQueueFuture();

              });

              // console.log('After find artist matches, we still need ' + requiredTracksCount);

              if (requiredTracksCount > 0) {

                var maxRandomTracks = 1;

                // add any new IDs to the disabledRecordIDs array;
                Airwaves.queueFuture.map(item => { disabledRecordIDs.push(item["Record ID"]) });

                // create string of random Autonumbers
                var matchAutonumberString = "";
                matchAutonumberString = matchAutonumberString + "OR(";

                for (let step = 0; step < maxRandomTracks; step++) {

                  matchAutonumberString = matchAutonumberString + "{Autonumber} = " + getRandomInt(0, Airwaves.totalTracks);

                  if (step !== maxRandomTracks - 1) {
                    matchAutonumberString = matchAutonumberString + ", ";
                  }

                  // console.log(matchAutonumberString);

                }

                matchAutonumberString = matchAutonumberString + ")";

                // console.log(matchAutonumberString);

                base('Tracks')
                  .select({
                    maxRecords: maxRandomTracks,
                    view: "🔍 Has Artist",
                    filterByFormula: "AND(" + matchAutonumberString.replace(/'/g, "\\\'") + ", FIND({" + tracksColumns["recordID"].replace(/'/g, "\\\'")  + "}, '" + disabledRecordIDs.join() + "') = 0)",
                    fields: tracksFieldsQuery
                  })
                  .firstPage(function (err, records) {

                    if (err) { console.error(err); return; }

                    records.forEach(function (record) {

                      // 1 less needed
                      maxRandomTracks--;

                      var track = [];
                      track["Title"] = "";
                      track["Record ID"] = "";
                      track["Play URL"] = "";
                      track["Track Name"] = "";
                      track["Track Type"] = "";
                      track["Artists"] = "";
                      track["Featured Artists"] = "";
                      track["Remix Artists"] = "";
                      track["Album"] = "";
                      track["Album Artwork URL"] = "";

                      if (tracksColumns["title"] in record.fields) {
                        track["Title"] = record.get(tracksColumns["title"]);
                      }

                      if (tracksColumns["recordID"] in record.fields) {
                        track["Record ID"] = record.get(tracksColumns["recordID"]);
                      }
                      
                      // ["Play URL"]
                      // Play URL = Track File [url] OR Google Drive URL
                      if (tracksColumns["trackFile"] in record.fields) {
                        // console.log("found trackfile in Airtable!");
                        track["Play URL"] = record.get(tracksColumns["trackFile"])[0].url;
                      } else {
                        if(tracksColumns["googleDriveURL"] in record.fields)
                        // console.log("found google drive trackfile!");
                        track["Play URL"] = record.get(tracksColumns["googleDriveURL"]);
                      }

                      if (tracksColumns["trackName"] in record.fields) {
                        track["Track Name"] = record.get(tracksColumns["trackName"]);
                      }

                      if (tracksColumns["trackType"] in record.fields) {
                        track["Track Type"] = record.get(tracksColumns["trackType"]);
                      }

                      if (tracksColumns["artists"] in record.fields) {
                        track["Artists"] = record.get(tracksColumns["artists"]);
                      }

                      if (tracksColumns["featuredArtists"] in record.fields) {
                        track["Featured Artists"] = record.get(tracksColumns["featuredArtists"]);
                      }

                      if (tracksColumns["remixArtists"] in record.fields) {
                        track["Remix Artists"] = record.get(tracksColumns["remixArtists"]);
                      }

                      if (tracksColumns["album"] in record.fields) {
                        track["Album"] = record.get(tracksColumns["album"]);
                      }
                      if (tracksColumns["artistIDs"] in record.fields) {
                        track["Artist IDs"] = record.get(tracksColumns["artistIDs"]);
                      }
                      if (tracksColumns["featuredArtistIDs"] in record.fields) {
                        track["Featured Artist IDs"] = record.get(tracksColumns["featuredArtistIDs"]);
                      }
                      if (tracksColumns["remixArtistIDs"] in record.fields) {
                        track["Remix Artist IDs"] = record.get(tracksColumns["remixArtistIDs"]);
                      }
                      if (tracksColumns["artistNamesLookup"] in record.fields) {
                        track["Artist Names Lookup"] = record.get(tracksColumns["artistNamesLookup"]);
                      }
                      if (tracksColumns["featuredArtistNamesLookup"] in record.fields) {
                        track["Featured Artist Names Lookup"] = record.get(tracksColumns["featuredArtistNamesLookup"]);
                      }
                      if (tracksColumns["remixArtistNamesLookup"] in record.fields) {
                        track["Remix Artist Names Lookup"] = record.get(tracksColumns["remixArtistNamesLookup"]);
                      }
                      if (tracksColumns["albumID"] in record.fields) {
                        track["Album ID"] = record.get(tracksColumns["albumID"]);
                      }
                      if (tracksColumns["playlists"] in record.fields) {
                        track["Playlists"] = record.get(tracksColumns["playlists"]);
                      }

                      if (tracksColumns["albumArtwork"] in record.fields) {
                        // console.log("found album artwork url!");

                        if("thumbnails" in record.get(tracksColumns["albumArtwork"])[0]) {
                          // console.log("has thumbnails!");

                          if("large" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                            // console.log("has large thumbnail!");
                            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.large.url;
                          }

                          else if("small" in record.get(tracksColumns["albumArtwork"])[0].thumbnails) {
                            // console.log("has small thumbnail!");
                            track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].thumbnails.small.url;
                          }
                        }
                        else {
                          // console.log("no thumbnails, just fullsize!");
                          track["Album Artwork URL"] = record.get(tracksColumns["albumArtwork"])[0].url;
                        }
                      }

                      Airwaves.trackCache.push(track);
                      Airwaves.queueFuture.push(track);

                      renderQueueFuture();

                    });

                  });

              }

            });

        }

      });

  }

}

document.addEventListener('click', function (element) {

  // console.log(element.target.className);

  // Copy-to-clipboard share button. Works whether the click lands on the button
  // or an inner element (e.g. the SVG/label) by walking up to [data-action].
  var shareEl = element.target.closest && element.target.closest('[data-action="copyShareLink"]');
  if (shareEl) {
    var shareType = shareEl.dataset.shareType;
    var shareId = shareEl.dataset.recordid;
    if (shareType === 'track' && !shareId) {
      shareId = Airwaves.queueCurrent && Airwaves.queueCurrent["Record ID"];
    }
    Airwaves.copyShareLink(shareType, shareId);
    return;
  }

  if (element.target.dataset.action === 'playTrack') {

    // console.log('clicked playTrack'); 
    Airwaves.play(element.target.dataset.recordid);

  }

  if (element.target.dataset.action === 'refreshNewTracks') {

    // console.log('clicked refreshNewTracks'); 
    Airwaves.listNewTracks();

  }

  if (element.target.dataset.action === 'refreshNewAlbums') {

    // Clear cache for current cluster and reload
    if (Airwaves.currentAlbumCluster === 'Recent') {
      Airwaves.collectionCache = Airwaves.collectionCache.filter(function(c) { return c["Type"] !== "album"; });
      Airwaves.listNewAlbums();
    } else {
      delete Airwaves.albumClusterCache[Airwaves.currentAlbumCluster];
      var currentAlbumCluster = artistClusters.find(function(c) { return c.key === Airwaves.currentAlbumCluster; });
      if (currentAlbumCluster) Airwaves.listAlbumsByCluster(currentAlbumCluster.key, currentAlbumCluster.letters);
    }

  }

  if (element.target.dataset.action === 'selectAlbumCluster') {

    var albumClusterKey = element.target.dataset.cluster;
    if (albumClusterKey === 'Recent') {
      Airwaves.listAlbumsByCluster('Recent', []);
    } else {
      var albumCluster = artistClusters.find(function(c) { return c.key === albumClusterKey; });
      if (albumCluster) Airwaves.listAlbumsByCluster(albumCluster.key, albumCluster.letters);
    }

  }

  if (element.target.dataset.action === 'addToQueue') {

    console.log('clicked addToQueue');
    Airwaves.addToQueue(element.target.dataset.recordid);

  }

  if (element.target.dataset.action === 'openCollection') {

    document.querySelector('.player').classList.remove('is-track-detail-open');
    document.body.__x.$data.selected = 'content-new';
    Airwaves.openCollection(element.target.dataset.recordid);

  }

  if (element.target.dataset.action === 'backFromCollection') {

    var previousLibrary = Airwaves.previousLibraryView || 'albums';
    document.body.__x.$data.library = previousLibrary;

  }

  if (element.target.dataset.action === 'openArtist') {

    document.querySelector('.player').classList.remove('is-track-detail-open');
    document.body.__x.$data.selected = 'content-new';
    Airwaves.openArtist(element.target.dataset.recordid);

  }

  if (element.target.dataset.action === 'backFromArtist') {

    document.body.__x.$data.library = 'artists';

  }

  if (element.target.dataset.action === 'refreshArtists') {

    // Clear cache for current cluster and reload
    delete Airwaves.artistClusterCache[Airwaves.currentArtistCluster];
    var currentCluster = artistClusters.find(function(c) { return c.key === Airwaves.currentArtistCluster; });
    if (currentCluster) Airwaves.listArtistsByCluster(currentCluster.key, currentCluster.letters);

  }

  if (element.target.dataset.action === 'selectArtistCluster') {

    var clusterKey = element.target.dataset.cluster;
    var cluster = artistClusters.find(function(c) { return c.key === clusterKey; });
    if (cluster) Airwaves.listArtistsByCluster(cluster.key, cluster.letters);

  }


  // Resolve transport-control clicks via closest() so a click on the inner SVG
  // icon still finds the button's data-action.
  var prevEl = element.target.closest && element.target.closest('[data-action="previousTrack"]');
  if (prevEl) {
    Airwaves.previousTrack();
  }

  if (element.target.dataset.action === 'skipForward') {

    // console.log('clicked skipForward');
    Airwaves.audio.currentTime += 15.0;

  }

  if (element.target.dataset.action === 'skipBackward') {

    // console.log('clicked skipBackward');
    Airwaves.audio.currentTime -= 15.0;

  }

  if (element.target.dataset.action === 'skipTrack') {

    // console.log('clicked skipTrack');
    Airwaves.skipTrack();

  }

  if (element.target.dataset.action === 'playPause') {

    // console.log('clicked playPause');
    Airwaves.playPause();

  }

  if (element.target.dataset.action === 'search') {

    Airwaves.search();

  }

  if (element.target.dataset.action === 'clearQueue') {

    Airwaves.clearQueue();

  }

  if (element.target.dataset.action === 'shuffleQueue') {

    Airwaves.shuffleQueue();

  }

  if (element.target.dataset.action === 'removeFromQueue') {

    Airwaves.removeFromQueue(element.target.dataset.recordid);

  }

  if (element.target.closest('.player-meta') && !element.target.closest('.c-track-detail__link')) {
    var isPortrait = window.matchMedia('(max-aspect-ratio: 13/11)').matches;
    if (isPortrait) Airwaves.toggleTrackDetail();
  }

});

Airwaves.toggleTrackDetail = function toggleTrackDetail() {
  var player = document.getElementById('player');
  var isOpen = player.classList.toggle('is-track-detail-open');
  if (isOpen) Airwaves.populateTrackDetail();
};

Airwaves.populateTrackDetail = function populateTrackDetail() {
  var track = Airwaves.queueCurrent;
  if (!track || !track["Record ID"]) return;

  document.getElementById('detailTrackNameValue').textContent = track["Track Name"] || '';

  var typeRow = document.getElementById('detailTrackType');
  var typeVal = document.getElementById('detailTrackTypeValue');
  if (track["Track Type"]) {
    typeVal.textContent = track["Track Type"];
    typeRow.classList.remove('is-hidden');
  } else {
    typeRow.classList.add('is-hidden');
  }

  var albumRow = document.getElementById('detailAlbum');
  var albumVal = document.getElementById('detailAlbumValue');
  if (track["Album"] && track["Album ID"]) {
    var albumIDs = track["Album ID"];
    var albumID = Array.isArray(albumIDs) ? albumIDs[0] : albumIDs;
    albumVal.innerHTML = "<button type='button' class='c-track-detail__link' data-action='openCollection' data-recordid='" + albumID + "'>" + track["Album"] + "</button>";
    albumRow.classList.remove('is-hidden');
  } else if (track["Album"]) {
    albumVal.textContent = track["Album"];
    albumRow.classList.remove('is-hidden');
  } else {
    albumRow.classList.add('is-hidden');
  }

  function renderArtistLinks(namesLookup, ids) {
    var nameList = namesLookup ? (Array.isArray(namesLookup) ? namesLookup : [namesLookup]) : [];
    var idList = ids ? (Array.isArray(ids) ? ids : [ids]) : [];
    if (nameList.length === 0) return '';
    return nameList.map(function(name, i) {
      var artistID = idList[i];
      if (artistID) {
        return "<button type='button' class='c-track-detail__link' data-action='openArtist' data-recordid='" + artistID + "'>" + name + "</button>";
      }
      return "<span>" + name + "</span>";
    }).join('');
  }

  var artistsRow = document.getElementById('detailArtists');
  var artistsVal = document.getElementById('detailArtistsValue');
  if (track["Artist Names Lookup"] && track["Artist Names Lookup"].length) {
    artistsVal.innerHTML = renderArtistLinks(track["Artist Names Lookup"], track["Artist IDs"]);
    artistsRow.classList.remove('is-hidden');
  } else if (track["Artists"]) {
    artistsVal.textContent = track["Artists"];
    artistsRow.classList.remove('is-hidden');
  } else {
    artistsRow.classList.add('is-hidden');
  }

  var featRow = document.getElementById('detailFeaturedArtists');
  var featVal = document.getElementById('detailFeaturedArtistsValue');
  if (track["Featured Artist Names Lookup"] && track["Featured Artist Names Lookup"].length) {
    featVal.innerHTML = renderArtistLinks(track["Featured Artist Names Lookup"], track["Featured Artist IDs"]);
    featRow.classList.remove('is-hidden');
  } else if (track["Featured Artists"]) {
    featVal.textContent = track["Featured Artists"];
    featRow.classList.remove('is-hidden');
  } else {
    featRow.classList.add('is-hidden');
  }

  var remixRow = document.getElementById('detailRemixArtists');
  var remixVal = document.getElementById('detailRemixArtistsValue');
  if (track["Remix Artist Names Lookup"] && track["Remix Artist Names Lookup"].length) {
    remixVal.innerHTML = renderArtistLinks(track["Remix Artist Names Lookup"], track["Remix Artist IDs"]);
    remixRow.classList.remove('is-hidden');
  } else if (track["Remix Artists"]) {
    remixVal.textContent = track["Remix Artists"];
    remixRow.classList.remove('is-hidden');
  } else {
    remixRow.classList.add('is-hidden');
  }

  var playlistRow = document.getElementById('detailPlaylists');
  var playlistVal = document.getElementById('detailPlaylistsValue');
  var playlistIDs = track["Playlists"];
  if (playlistIDs && playlistIDs.length) {
    var idList = Array.isArray(playlistIDs) ? playlistIDs : [playlistIDs];
    var links = idList.map(function(id) {
      var cached = Airwaves.collectionCache.find(function(c) { return c["Record ID"] === id; });
      var name = cached ? cached["Name"] : id;
      return "<button type='button' class='c-track-detail__link' data-action='openCollection' data-recordid='" + id + "'>" + name + "</button>";
    }).join('');
    playlistVal.innerHTML = links;
    playlistRow.classList.remove('is-hidden');
  } else {
    playlistRow.classList.add('is-hidden');
  }
};

/*
if("serviceWorker" in navigator) {
  navigator.serviceWorker.register("sw.js").then(registration => {
    console.log("SW Registered success");
    console.log(registration);
  }).catch(error => {
    console.log("SW Registration failed");
    console.log(error);
  });
}
*/

/*
Airwaves.queueCurrent["Track Name"] = trackName;
Airwaves.queueCurrent["Artists"] = artist;
Airwaves.queueCurrent["Album"] = album;
Airwaves.queueCurrent["Album Artwork URL"] = albumArtworkURL;
*/

/*
if ('URLSearchParams' in window) {
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.set("track", recordID);
  window.location.search = searchParams.toString();
}
*/
